﻿
window.afficheDateCaisseLigne = true
window.afficheHeureCaisseLigne = true
window.cDocCptDetail = function (bddRef, dataDocCptDetail) {
    var Me = this;
    if (typeof bddRef == "undefined") throw "manque bddRef"
    if (dataDocCptDetail) {
        this.docCpt = dataDocCptDetail.docCpt
        this.docCptClient = dataDocCptDetail.docCptClient
        this.docCptSociete = dataDocCptDetail.docCptSociete
        this.docCptLigne = dataDocCptDetail.docCptLigne
        this.docCptModeReglement = dataDocCptDetail.docCptModeReglement
        this.docCptAvoir = dataDocCptDetail.docCptAvoir
        //if (this.docCpt.nom_base.endsWith("_aagest")) this.isTest = false
    }

    this.mGetResumeString = function () {
        var tot = JSON.stringify(this.docCpt) + JSON.stringify(this.docCptClient) + JSON.stringify(this.docCptClient)
        this.docCptLigne.forEach(function (lig) {
            var div = null
            if (lig.div) {
                div = lig.div
                delete lig.div
            }
            tot += JSON.stringify(lig)
            if (div) lig.div = div
        })
        this.docCptModeReglement.forEach(function (lig) {
            var div = null
            if (lig.div) {
                div = lig.div
                delete lig.div
            }
            tot += JSON.stringify(lig)
            if (div) lig.div = div
        })
        return tot
    }

    this.mGetDataDocCptDetail = function () {
        return {
            docCpt: Me.docCpt,
            docCptClient: Me.docCptClient,
            docCptSociete: Me.docCptSociete,
            docCptLigne: Me.docCptLigne,
            docCptModeReglement: Me.docCptModeReglement,
            docCptAvoir: Me.docCptAvoir
        }
    }

    this.mGetMaxTriDocCptLigne = function () {
        if (this.docCptLigne.length == 0) { return 0 }
        else { return Math.max(... this.docCptLigne.map(x => x.tri)); }
    }

    this.bddRef = bddRef
    this.isTest = (bddRef.objCptCli.data.offre_essai == "1" || bddRef.isDemo)
    this.displayQrCode = true

    this.mReset = function (dataDocCptDetailNew, funcOk) {
        dataDocCptDetail = dataDocCptDetailNew
        this.docCpt = dataDocCptDetailNew.docCpt
        this.docCptClient = dataDocCptDetailNew.docCptClient
        this.docCptSociete = dataDocCptDetailNew.docCptSociete
        this.docCptLigne = ((typeof dataDocCptDetailNew.docCptLigne == 'undefined') ? [] : dataDocCptDetailNew.docCptLigne)
        this.docCptModeReglement = ((typeof dataDocCptDetailNew.docCptModeReglement == 'undefined') ? [] : dataDocCptDetailNew.docCptModeReglement)
        this.docCptAvoir = ((typeof dataDocCptDetailNew.docCptAvoir == 'undefined') ? [] : dataDocCptDetailNew.docCptAvoir)
        Me.mGetLogoSociete(function () {
            funcOk(Me)
        })
    }

    this.mRemoveId = function () {
        this.docCpt.id_doc_cpt = null
        this.docCpt.id_statut_com = 1
        this.docCpt.dcr = new Date()
        this.docCpt.dmo = new Date()

        this.docCptClient.id_doc_cpt = null
        this.docCptClient.id_doc_cpt_client = null
        this.docCptClient.dcr = new Date()
        this.docCptClient.dmo = new Date()

        this.docCptSociete.id_doc_cpt = null
        this.docCptSociete.id_doc_cpt_societe = null
        this.docCptSociete.dcr = new Date()
        this.docCptSociete.dmo = new Date()


        this.docCptLigne.forEach(function (lig) {
            lig.id_doc_cpt = null
            lig.id_doc_cpt_ligne = null
            lig.dcr = new Date()
            lig.dmo = new Date()
        })
        this.docCptModeReglement.forEach(function (lig) {
            lig.id_doc_cpt = null
            lig.id_doc_cpt_mode_reglement = null
            lig.dcr = new Date()
            lig.dmo = new Date()
        })
        this.docCptAvoir = []
        this.mRecalculLigneDetail()
    }

    this.mGetEnteteNumDocument = function () {
        var objSoc = this.mGetObjetSocieteRef()
        switch (parseInt(this.docCpt.id_type_com)) {
            case 1: return objSoc.data.entete_devis; break;
            case 2: return objSoc.data.entete_commande; break;
            case 3: return objSoc.data.entete_facture; break;
            case 4: return objSoc.data.entete_recapitulatif; break;
            case 5: return objSoc.data.entete_ticket; break;
            default: return ""; break;
        }
    }
    this.mGetTotalQuantite = function () {
        var qte = 0
        this.docCptLigne.forEach(function (lig) { qte += parseInt(lig.qte) })
        return qte
    }
    this.mGetTotalTtc = function () {
        var totTtc = 0
        this.docCptLigne.forEach(function (lig) { totTtc += lig.totttc_avec_remise_pied })
        return totTtc
    }
    this.mGetNomDocument = function () {
        var txt = ""
        switch (parseInt(this.docCpt.id_type_com)) {
            case 1: txt = "devis"; break;
            case 2: txt = "commande"; break;
            case 3:
                //txt = "facture";
                if (this.docCpt.id_doc_cpt_source_avoir) {
                    txt = "avoir";
                } else {
                    txt = "facture";
                }
                break;
            case 4: txt = "note"; break;
            case 5: txt = "ticket"; break;
        }
        return txt
    }
    this.mIsDuplicataActif = function () {
        var txt = ""
        switch (parseInt(this.docCpt.id_type_com)) {
            case 1: return this.bddRef.paraAppli.mGetPara("doccpt_general_doccpt_devis_duplicata_active"); break;
            case 2: return this.bddRef.paraAppli.mGetPara("doccpt_general_doccpt_commande_duplicata_active"); break;
            case 3: return this.bddRef.paraAppli.mGetPara("doccpt_general_doccpt_facture_duplicata_active"); break;
            default: return true; break;
        }
        return txt
    }
    this.mGetNumDocument = function () {
        if (this.docCpt.id_statut_com == "1") {
            return "N°#" + this.docCpt.id_doc_cpt
        } else {
            return ((this.mGetEnteteNumDocument().length > 0) ? this.mGetEnteteNumDocument() : "N°") + this.docCpt.id_document + "" + ((this.isTest) ? "_TEST" : "")
        }
    }

    this.mGetNameForPdfFile = function () {
        //var nomSoc = this.mGetObjetSocieteRef().data.nom.replace(/[/\\?%*:|"<>]/g, '_');
        let nomSoc = this.mGetObjetSocieteRef().data.nom;
        nomSoc = nomSoc.replace(/[\\/:*?"<>|#%&{}`~@!$\^+=;,'()\[\]\s]/g, '_');
        nomSoc = nomSoc.replace(/\s+/g, '_'); // Remplace les espaces multiples
        nomSoc = nomSoc.replace(/^\.+|\.+$/g, ''); // Supprime les points en début/fin
        nomSoc = nomSoc.substring(0, 255); // Limite à 255 caractères
        if (this.docCpt.id_statut_com == "2") { return this.mGetNomDocument() + "_" + ((nomSoc.length > 0) ? nomSoc + "_" : "") + this.mGetEnteteNumDocument() + this.docCpt.id_document }
        else { return this.mGetNomDocument() + "_brouillon_" + ((nomSoc.length > 0) ? nomSoc + "_" : "") + "#" + this.docCpt.id_doc_cpt }
    }

    this.mGetUnUne = function () {
        var txt = ""
        switch (parseInt(this.docCpt.id_type_com)) {
            case 1: txt = "un"; break;
            case 2: txt = "une"; break;
            case 3:
                //txt = "une";
                if (this.docCpt.id_doc_cpt_source_avoir) {
                    txt = "un";
                } else {
                    txt = "une";
                }
                break;
            case 4: txt = "une"; break;
            case 5: txt = "un"; break;
        }
        return txt
    }

    this.mGetLeLa = function () {
        var txt = ""
        switch (parseInt(this.docCpt.id_type_com)) {
            case 1: txt = "le "; break;
            case 2: txt = "la "; break;
            case 3:
                txt = "la";
                if (this.docCpt.id_doc_cpt_source_avoir) {
                    txt = "l'";
                } else {
                    txt = "la ";
                }
                break;
            case 4: txt = "la "; break;
            case 5: txt = "le "; break;
        }
        return txt
    }

    this.mGetDuDeLa = function () {
        var txt = ""
        switch (parseInt(this.docCpt.id_type_com)) {
            case 1: txt = "du "; break;
            case 2: txt = "de la "; break;
            case 3:
                //txt = "de la ";
                if (this.docCpt.id_doc_cpt_source_avoir) {
                    txt = "de l'";
                } else {
                    txt = "de la ";
                }
                break;
            case 4: txt = "de la "; break;
            case 5: txt = "du "; break;
        }
        return txt
    }

    this.hasQtePositive = function () {
        var result = false
        this.docCptLigne.forEach(function (lig) {
            if (lig.qte > 0) result = true
        })
        return result
    }

    this.mGetObjetSocieteRef = function () {
        if (this.docCpt.id_statut_com == "1") { return bddRef.getObjet("societe", this.docCpt.id_societe) }
        else { return bddRef.getObjet(this.docCptSociete) }
    }
    this._logoSociete = ""
    this.mGetLogoSociete = function (funcOk, async) {
        //if (this.is_externe) {
        //    bddRef.mAjaxCall({
        //        command: "getimagedata",
        //        nom_table: "doc_cpt_societe",
        //        id: Me.docCptSociete.id_doc_cpt_societe,
        //    }, function (data) {
        //        Me._logoSociete = data.urldataimagebase64
        //        if (typeof funcOk != 'undefined') funcOk()
        //    })
        //    return this._logoSociete
        //} else {
        objSoc = this.mGetObjetSocieteRef()
        objSoc.mGetData64Image(function (dataImgUrl) {
            Me._logoSociete = dataImgUrl
            if (typeof funcOk != 'undefined') funcOk(dataImgUrl)
        }, async)
        return this._logoSociete
        //}
    }
    this.mRempliSociete = function ($ele) {
        $ele.css("height", (($ele.innerHeight > 0) ? $ele.innerHeight + 'px' : ""))
        $ele.empty()
        //$ele.css("opacity", "0.4")
        var objSoc = null
        objSoc = this.mGetObjetSocieteRef()
        $("<div style='font-weight:bold;font-size:100%;'>" + objSoc.data.nom + "" + ((this.isTest) ? "_TEST" : "") + "</div>").appendTo($ele)
        if (objSoc.data.ad1 != null && objSoc.data.ad1.length > 0) $("<div style='font-size:80%;'>" + objSoc.data.ad1 + "</div>").appendTo($ele)
        if (objSoc.data.ad2 != null && objSoc.data.ad2.length > 0) $("<div style='font-size:80%;'>" + objSoc.data.ad2 + "</div>").appendTo($ele)
        if (objSoc.data.ad3 != null && objSoc.data.ad3.length > 0) $("<div style='font-size:80%;'>" + objSoc.data.ad3 + "</div>").appendTo($ele)
        $("<div style='font-size:80%;'>" + objSoc.data.cp + " " + objSoc.data.ville + "" + ((objSoc.data.cedex != null && objSoc.data.cedex.length > 0) ? " " + objSoc.data.cedex : "") + " " + objSoc.data.pays + "</div>").appendTo($ele)
        var tel = objSoc.objetMetier.mGetTelMiseEnforme()
        if (tel.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>☎</span>" + tel + "</div>").appendTo($ele)
        if (this.isNoteTicket()) {
            if (objSoc.data.siret != null && objSoc.data.siret.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>Siret: </span>" + objSoc.data.siret + "</div>").appendTo($ele)
            if (objSoc.data.tva_intra != null && objSoc.data.tva_intra.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>TVA intra: </span>" + objSoc.data.tva_intra + "</div>").appendTo($ele)
            if (objSoc.data.naf_ape != null && objSoc.data.naf_ape.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>APE: </span>" + objSoc.data.naf_ape + "</div>").appendTo($ele)
        }
        $ele.css("height", "")
    }

    this.isNoteTicket = function () { return this.docCpt.id_type_com == '4' || this.docCpt.id_type_com == '5'; }
    this.isValidated = function () { return this.docCpt.id_statut_com == "2" }
    this.isSocieteAssujettiTva = function () {
        if (this.docCpt.id_statut_com == "1") {
            return bddRef.getObjet("societe", this.docCpt.id_societe).data.assujetti_tva == "1"
        } else { return this.docCptSociete.assujetti_tva == "1" }
    }
    this.isDocumentAssujettiTva = function () {
        if (this.docCpt.id_statut_com == "1") {
            return bddRef.getObjet("societe", this.docCpt.id_societe).data.assujetti_tva == "1" && this.docCpt.cas_doc_ht == "0"
        } else { return this.docCptSociete.assujetti_tva == "1" && this.docCpt.cas_doc_ht == "0" }
    }

    this.mGetLstDocCptModeReglementRenduMonnaie = function () {
        return this.docCptModeReglement.filter(function (modeReg) {
            return (modeReg.id_mode_reglement == "4" && modeReg.mt < 0)
        })
    }
    this.mGetTotalRenduMonnaie = function () {
        var renduMonnaie = 0
        this.mGetLstDocCptModeReglementRenduMonnaie().forEach(function (modeReg) {
            renduMonnaie += parseFloat(modeReg.mt)
        })
        return parseFloat(renduMonnaie.toFixed(2))
    }

    this.mGetLstDocCptModeReglementRenduAvoir = function () {
        return this.docCptModeReglement.filter(function (modeReg) {
            return (modeReg.id_mode_reglement == "9" && modeReg.mt < 0)
        })
    }
    this.mGetTotalRenduAvoir = function () {
        var renduAvoir = 0
        this.mGetLstDocCptModeReglementRenduAvoir().forEach(function (modeReg) {
            renduAvoir += parseFloat(modeReg.mt)
        })
        return parseFloat(renduAvoir.toFixed(2))
    }

    this.mGetObjetDataClient = function () {
        var objClient = null
        if (this.docCptClient.id != null && objClient == null) {
            objClient = bddRef.getObjet(bddRef.table.mGetItem(this.docCptClient.id_table).nom, this.docCptClient.id)
        }
        return ((objClient == null) ? null : objClient.data)
    }
    this.mGetEmailClient = function () {
        return this.docCptClient.adresse_email
    }
    //this.mRempliClient = function ($ele, option) {
    //    $ele.css("height", (($ele.innerHeight > 0) ? $ele.innerHeight + 'px' : ""))
    //    $ele.empty()
    //    if (this.docCptClient.has_client == "1") {
    //        var $DivContainerClient = $("<div style='padding:0 10px;font-size:100%;'/>").appendTo($ele)
    //        if (this.isNoteTicket()) $DivContainerClient.css("padding", "5px 30px 10px 30px;")
    //        //$("<span style=';font-style:italic;font-variant:small-caps;'><u>Client</u></span>").appendTo($DivContainerClient)
    //        //$("<br/>").appendTo($DivContainerClient)
    //        //var dataClient = this.mGetDataClient()
    //        if (this.docCptClient.nom != null && this.docCptClient.nom.length > 0) {
    //            $("<span class='nom_client' style='font-weight:bold;font-size:120%;'>" + this.docCptClient.nom + "</span>").appendTo($DivContainerClient)
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        if ((this.docCptClient.con_nom != null && this.docCptClient.con_nom.length > 0) || (this.docCptClient.con_prenom != null && this.docCptClient.con_prenom.length > 0)) {
    //            var txt = ""
    //            if (this.docCptClient.con_nom != null && this.docCptClient.con_nom.length > 0) txt += this.docCptClient.con_nom.toUpperCase()
    //            if (this.docCptClient.con_prenom != null && this.docCptClient.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + this.docCptClient.con_prenom
    //            $("<span class='nom_client' style='font-style:italic;font-size:120%;'>" + txt + "</span>").appendTo($DivContainerClient)
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        if (this.docCptClient.ad1 != null && this.docCptClient.ad1.length > 0) {
    //            $("<span style='font-size:80%;'>" + this.docCptClient.ad1 + "</span>").appendTo($DivContainerClient)
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        if (this.docCptClient.ad2 != null && this.docCptClient.ad2.length > 0) {
    //            $("<span style='font-size:80%;'>" + this.docCptClient.ad2 + "</span>").appendTo($DivContainerClient)
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        if (this.docCptClient.ad3 != null && this.docCptClient.ad3.length > 0) {
    //            $("<span style='font-size:80%;'>" + dataCthis.docCptClientlient.ad3 + "</span>").appendTo($DivContainerClient)
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        var txtAdr = ""
    //        if (this.docCptClient.cp != null) txtAdr = this.docCptClient.cp
    //        if (this.docCptClient.ville != null) txtAdr += ((txtAdr.length > 0) ? " " : "") + this.docCptClient.ville
    //        if (this.docCptClient.cedex != null) txtAdr += ((txtAdr.length > 0) ? " " : "") + this.docCptClient.cedex
    //        if (this.docCptClient.pays != null) txtAdr += ((txtAdr.length > 0) ? ", " : "") + this.docCptClient.pays
    //        if (txtAdr.length > 0) {
    //            $("<span style='font-size:80%;'>" + txtAdr + "</span>").appendTo($DivContainerClient)
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        var hasEmailTel = false
    //        if (this.docCptClient.adresse_email != null && this.docCptClient.adresse_email.length > 0) {
    //            $("<span style='font-size:80%;'><u>" + this.docCptClient.adresse_email + "</u></span>").appendTo($DivContainerClient)
    //            hasEmailTel = true
    //        }
    //        if (this.docCptClient.tel_sms != null && this.docCptClient.tel_sms.length > 0) {
    //            if (this.docCptClient.adresse_email != null && this.docCptClient.adresse_email.length > 0) $("<span> &bull; </span>").appendTo($DivContainerClient)
    //            var tel = new cTelephone(this.docCptClient.tel_code_pays, this.docCptClient.tel_sms)
    //            $("<span style='font-size:80%;'>" + tel.mGetValueMiseEnForme() + "</span>").appendTo($DivContainerClient)
    //            hasEmailTel = true
    //        }
    //        if (this.docCptClient.mob_sms != null && this.docCptClient.mob_sms.length > 0) {
    //            if (hasEmailTel) $("<span> &bull; </span>").appendTo($DivContainerClient)
    //            var tel = new cTelephone(this.docCptClient.mob_code_pays, this.docCptClient.mob_sms)
    //            $("<span style='font-size:80%;'>" + tel.mGetValueMiseEnForme() + "</span>").appendTo($DivContainerClient)
    //            hasEmailTel = true
    //        }
    //        if (hasEmailTel) {
    //            $("<br/>").appendTo($DivContainerClient)
    //        }
    //        if (this.docCptClient.tva_intra != null && this.docCptClient.tva_intra.length > 0) {
    //            $("<span style='font-size:80%;'><span style='opacity:0.8;font-size:80%;'>TVA intra.: </span>" + this.docCptClient.tva_intra + "</span>").appendTo($DivContainerClient)
    //        }
    //        if (this.docCptClient.siret != null && this.docCptClient.siret.length > 0) {
    //            if (this.docCptClient.tva_intra != null && this.docCptClient.tva_intra.length > 0) $("<span> &bull; </span>").appendTo($DivContainerClient)
    //            $("<span style='font-size:80%;'><span style='opacity:0.8;font-size:80%;'>Siret: </span>" + this.docCptClient.siret + "</span>").appendTo($DivContainerClient)
    //        }
    //        if (option.forPrint) { $ele.css("display", "") }
    //        else { $ele.slideDown(option.tempoAnimate) }
    //    } else {
    //        if (!option.forPrint) $("<div style='padding:0 10px;font-size:100%;'>(Aucun client)</div>").appendTo($ele)
    //        //if (option.forPrint) { $ele.css("display", "none"); $ele.empty() }
    //        //else { $ele.slideUp(option.tempoAnimate, "swing", function () { $ele.empty() }) }
    //    }
    //    $ele.css("height", "")
    //}

    //this.mGetPhraseChampManquantClient = function () {
    //    var txtManque = ""
    //    if (this.docCptClient.has_client == "1") {
    //        //var dataClient = this.mGetDataClient()
    //        switch (parseInt(this.docCptClient.id_table)) {
    //            case parseInt(bddRef.getObjet("structures").mGetTable().id_table):
    //            case parseInt(bddRef.getObjet("structures_contact").mGetTable().id_table):
    //            case parseInt(bddRef.getObjet("compte_client").mGetTable().id_table):
    //                if (this.docCptClient.nom == null || this.docCptClient.nom.length == 0) txtManque = "nom"
    //                if (this.docCptClient.cp == null || this.docCptClient.cp.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "code postal"
    //                if (this.docCptClient.ville == null || this.docCptClient.ville.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "ville"
    //                if ((this.docCptClient.cp == null || this.docCptClient.cp.length == 0) || (this.docCptClient.ville == null || this.docCptClient.ville.length == 0)) txtManque += " (vérifier que les informations sont saisie au bon endroit sur l'adresse postale)"
    //                //if (dataClient.tva_intra == null || dataClient.tva_intra.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "TVA intracommunautaire"
    //                if (txtManque.length > 0) txtManque += " du client"
    //                break;
    //            case parseInt(bddRef.getObjet("contact").mGetTable().id_table):
    //                if (this.docCptClient.nom == null || this.docCptClient.nom.length == 0) txtManque = "nom"
    //                if (this.docCptClient.cp == null || this.docCptClient.cp.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "code postal"
    //                if (this.docCptClient.ville == null || this.docCptClient.ville.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "ville"
    //                if (txtManque.length > 0) txtManque += " du client"
    //                if ((this.docCptClient.cp == null || this.docCptClient.cp.length == 0) || (this.docCptClient.ville == null || this.docCptClient.ville.length == 0)) txtManque += " (vérifier que les informations sont saisie au bon endroit sur l'adresse postale)"
    //                break;
    //        }
    //    }
    //    return txtManque
    //}
    this.mGetPhraseChampManquantClient = function (docCptClient) {
        var txt = ""
        if (typeof docCptClient == 'undefined') docCptClient = Me.docCptClient

        switch (parseInt(docCptClient.id_type_client)) {
            case 0:
                if (!docCptClient.con_nom || docCptClient.con_nom.length == 0) txt += "&bull; le nom de votre client"
                if (!docCptClient.adresse_email || docCptClient.adresse_email.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; l'adresse email de votre client"
                break;
            case 1:
                if (!docCptClient.nom || docCptClient.nom.length == 0) txt += "&bull; le nom de la société de votre client"
                if (!docCptClient.siret || docCptClient.siret.length == 0) txt += "&bull; le siret de la société de votre client"
                break;
            case 2:
                if (!docCptClient.nom || docCptClient.nom.length == 0) txt += "&bull; le nom de la société de votre client"
                if (!docCptClient.tva_intra || docCptClient.tva_intra.length == 0) txt += "&bull; le Numéro de TVA intracommunautaire de la société de votre client"
                break;
            case 3:
                if (!docCptClient.nom || docCptClient.nom.length == 0) txt += "&bull; le nom de la société de votre client"
                if (!docCptClient.adresse_email || docCptClient.adresse_email.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; l'adresse email de votre client"
                break;
        }
        //if ((docCptClient.nom && docCptClient.nom.length > 0) ||
        //    (docCptClient.siret && docCptClient.siret.length > 0) ||
        //    (docCptClient.tvaintra && docCptClient.tvaintra.length > 0)) {
        //    //on est sur une societé
        //    if (!docCptClient.nom || docCptClient.nom.length == 0) txt += "&bull; le nom de la société de votre client"
        //} else {
        //    //on est sur un particulier
        //    if (!docCptClient.con_nom || docCptClient.con_nom.length == 0) txt += "&bull; le nom de votre client"
        //}
        if (!docCptClient.ad1 || docCptClient.ad1.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; la première ligne d'adresse du client"
        if (!docCptClient.cp || docCptClient.cp.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; le code postal du client"
        if (!docCptClient.ville || docCptClient.ville.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; la ville du client"
        if (!docCptClient.pays || docCptClient.pays.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; le pays du client"
        if (!docCptClient.code_pays || docCptClient.code_pays.length == 0) txt += (txt.length > 0 ? "<br/>" : "") + "&bull; le code pays du client (veuillez saisir un pays dans la liste proposée pour disposer d'un code pays normalisé)"
        return txt
    }

    this.needTvaIntra = function () {
        var needTVaIntra = false
        if (this.docCptClient.has_client == "1") {
            //var dataClient = this.mGetDataClient()
            switch (parseInt(this.docCptClient.id_table)) {
                case parseInt(bddRef.getObjet("structures").mGetTable().id_table):
                case parseInt(bddRef.getObjet("structures_contact").mGetTable().id_table):
                case parseInt(bddRef.getObjet("compte_client").mGetTable().id_table):
                    if (this.docCptClient.tva_intra == null || this.docCptClient.tva_intra.length == 0) needTVaIntra = true
                    break;
                case parseInt(bddRef.getObjet("contact").mGetTable().id_table):
                    break;
            }
        }
        return needTVaIntra
    }

    this.mustHaveClient = function (ticketEnFacture) {
        if (typeof ticketEnFacture == 'undefined') ticketEnFacture = false
        return ((this.docCpt.id_type_com == "1" ||
            this.docCpt.id_type_com == "2" ||
            this.docCpt.id_type_com == "3" ||
            (this.docCpt.id_type_com == "5" && ticketEnFacture)) && this.docCptClient.id_table == null)
    }

    this.mGetPhraseChampManquantSociete = function () {
        var txtManque = ""
        bddRef.getObjet("societe", this.docCpt.id_societe).objetMetier.mGetLstLibelleChampManquantForFacture(this.docCpt.id_type_com).forEach(function (libChamp) {
            txtManque += ((txtManque.length > 0) ? ", " : "") + libChamp
        })
        return txtManque
    }

    this.mGetTotalRemiseTtc = function () {
        var totRemiseTtc = ((this.docCpt.type_remise == 0) ? 0 : ((this.docCpt.mt_remise_ttc == null) ? 0 : this.docCpt.mt_remise_ttc.toFixed2()))
        this.docCptLigne.forEach(function (lig) {
            if (lig.mt_remise_ttc == null) lig.mt_remise_ttc = 0
            if (lig.type_remise != 0) totRemiseTtc += lig.mt_remise_ttc.toFixed2()
        })
        return totRemiseTtc
    }

    this.mGetTotalRemiseHt = function () {
        var totRemiseHt = ((this.docCpt.type_remise == 0) ? 0 : ((this.docCpt.mt_remise_ht == null) ? 0 : this.docCpt.mt_remise_ht.toFixed2()))
        this.docCptLigne.forEach(function (lig) {
            if (lig.mt_remise_ht == null) lig.mt_remise_ht = 0
            if (lig.type_remise != 0) totRemiseHt += lig.mt_remise_ht.toFixed2()
        })
        return totRemiseHt
    }
    this.mGetTotalReglement = function () {
        var mt = 0
        Me.docCptModeReglement.forEach(function (modeReg) {
            mt += parseFloat(modeReg.mt)
        })
        return mt
    }


    this.mRemoveClient = function (funcOk, funcKo) {
        this.docCptClient.has_client = "0" //gérer au cas ou on supprime la fiche, on garde la facture sur les factures validés
        this.docCptClient.nom = null
        this.docCptClient.con_nom = null
        this.docCptClient.con_prenom = null
        this.docCptClient.ad1 = null
        this.docCptClient.ad2 = null
        this.docCptClient.ad3 = null
        this.docCptClient.cp = null
        this.docCptClient.ville = null
        this.docCptClient.cedex = null
        this.docCptClient.pays = null
        this.docCptClient.tva_intra = null
        this.docCptClient.siret = null
        this.docCptClient.id_table = null
        this.docCptClient.id = null
        this.docCptClient.nom_base = null
        this.docCptClient.tel_code_pays = null
        this.docCptClient.tel_number = null
        this.docCptClient.tel_complet = null
        this.docCptClient.tel_sms = null
        this.docCptClient.tel_error = null
        this.docCptClient.tel_num_type = null
        this.docCptClient.mob_code_pays = null
        this.docCptClient.mob_number = null
        this.docCptClient.mob_complet = null
        this.docCptClient.mob_sms = null
        this.docCptClient.mob_error = null
        this.docCptClient.mob_num_type = null
        this.mSaveDocCptClient(false, funcOk, funcKo)
    }
    ////return true si update
    //this.mUpdateDocCptClient = function (objClient) {
    //    if (typeof objClient == 'undefined') objClient = null
    //    if (this.docCptClient.id != null && objClient == null) {
    //        objClient = bddRef.getObjet(bddRef.table.mGetItem(this.docCptClient.id_table).nom, this.docCptClient.id)
    //    }
    //    var change = false
    //    if (objClient == null) {
    //        if (this.docCptClient.nom != null) { change = true; this.docCptClient.nom = null }
    //        if (this.docCptClient.ad1 != null) { change = true; this.docCptClient.ad1 = null }
    //        if (this.docCptClient.ad2 != null) { change = true; this.docCptClient.ad2 = null }
    //        if (this.docCptClient.ad3 != null) { change = true; this.docCptClient.ad3 = null }
    //        if (this.docCptClient.cp != null) { change = true; this.docCptClient.cp = null }
    //        if (this.docCptClient.ville != null) { change = true; this.docCptClient.ville = null }
    //        if (this.docCptClient.cedex != null) { change = true; this.docCptClient.cedex = null }
    //        if (this.docCptClient.pays != null) { change = true; this.docCptClient.pays = null }
    //        if (this.docCptClient.tva_intra != null) { change = true; this.docCptClient.tva_intra = null }
    //        if (this.docCptClient.siret != null) { change = true; this.docCptClient.siret = null }
    //        if (this.docCptClient.adresse_email != null) { change = true; this.docCptClient.adresse_email = null }
    //        if (this.docCptClient.id != null) { change = true; this.docCptClient.id = null }
    //        if (this.docCptClient.id_table != null) { change = true; this.docCptClient.id_table = null }
    //        if (this.docCptClient.has_client != 0) { change = true; this.docCptClient.has_client = 0 }
    //        if (this.docCptClient.nom_base != null) { change = true; this.docCptClient.nom_base = null }
    //        if (this.docCptClient.tel_code_pays != null) { change = true; this.docCptClient.tel_code_pays = null }
    //        if (this.docCptClient.tel_number != null) { change = true; this.docCptClient.tel_number = null }
    //        if (this.docCptClient.tel_complet != null) { change = true; this.docCptClient.tel_complet = null }
    //        if (this.docCptClient.tel_sms != null) { change = true; this.docCptClient.tel_sms = null }
    //        if (this.docCptClient.tel_error != null) { change = true; this.docCptClient.tel_error = null }
    //        if (this.docCptClient.tel_num_type != null) { change = true; this.docCptClient.tel_num_type = null }
    //        if (this.docCptClient.mob_code_pays != null) { change = true; this.docCptClient.mob_code_pays = null }
    //        if (this.docCptClient.mob_number != null) { change = true; this.docCptClient.mob_number = null }
    //        if (this.docCptClient.mob_complet != null) { change = true; this.docCptClient.mob_complet = null }
    //        if (this.docCptClient.mob_sms != null) { change = true; this.docCptClient.mob_sms = null }
    //        if (this.docCptClient.mob_error != null) { change = true; this.docCptClient.mob_error = null }
    //        if (this.docCptClient.mob_num_type != null) { change = true; this.docCptClient.mob_num_type = null }
    //    } else {
    //        if (this.docCptClient.id != objClient.cle()) { change = true; this.docCptClient.id = objClient.cle() }
    //        if (this.docCptClient.id_table != objClient.mGetTable().id_table) { change = true; this.docCptClient.id_table = objClient.mGetTable().id_table }
    //        if (this.docCptClient.has_client != "1") { change = true; this.docCptClient.has_client = "1" }
    //        if (this.docCptClient.id_table == bddRef.getObjet("compte_client").mGetTable().id_table) {
    //            try {
    //                throw new Error("Sur les documents comptable, le client est un compte_client. C'est pas normal");
    //            } catch (e) {
    //                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
    //            }
    //            //on est sur un compte client
    //            if (this.docCptClient.nom != objClient.objetMetier.mGetNom()) { change = true; this.docCptClient.nom = objClient.objetMetier.mGetNom(); }
    //            if (this.docCptClient.ad1 != objClient.data.ad1) { change = true; this.docCptClient.ad1 = objClient.data.ad1 }
    //            if (this.docCptClient.ad2 != objClient.data.ad2) { change = true; this.docCptClient.ad2 = objClient.data.ad2 }
    //            if (this.docCptClient.ad3 != objClient.data.ad3) { change = true; this.docCptClient.ad3 = objClient.data.ad3 }
    //            if (this.docCptClient.cp != objClient.data.cp) { change = true; this.docCptClient.cp = objClient.data.cp }
    //            if (this.docCptClient.ville != objClient.data.ville) { change = true; this.docCptClient.ville = objClient.data.ville }
    //            if (this.docCptClient.pays != objClient.data.pays) { change = true; this.docCptClient.pays = objClient.data.pays }
    //            if (this.docCptClient.tva_intra != objClient.data.tva_intra) { change = true; this.docCptClient.tva_intra = objClient.data.tva_intra }
    //            if (this.docCptClient.siret != objClient.data.siret) { change = true; this.docCptClient.siret = objClient.data.siret }
    //            if (this.docCptClient.adresse_email != objClient.data.adresse_email) { change = true; this.docCptClient.adresse_email = objClient.data.adresse_email }
    //            if (this.docCptClient.nom_base != objClient.data.nom_base) { change = true; this.docCptClient.nom_base = objClient.data.nom_base }
    //        } else {
    //            var clDataTemp = new cDataTemplateStrCon(bddRef, objClient.mGetTable().id_table, objClient.cle())

    //            if (this.docCptClient.nom != clDataTemp.mGetNom()) { change = true; this.docCptClient.nom = clDataTemp.mGetNom(); }
    //            //var champTableData = new cTableChampData(bddRef, objClient.objetMetier.mGetLstChampTableData())
    //            //var adr = objClient.objetMetier.mGetChampAdressePostaleDefaut()
    //            var adr = clDataTemp.mGetChampAdressePostaleDefaut()
    //            if (adr == null) {
    //                if (this.docCptClient.ad1 != null) { change = true; this.docCptClient.ad1 = null }
    //                if (this.docCptClient.ad2 != null) { change = true; this.docCptClient.ad2 = null }
    //                if (this.docCptClient.ad3 != null) { change = true; this.docCptClient.ad3 = null }
    //                if (this.docCptClient.cp != null) { change = true; this.docCptClient.cp = null }
    //                if (this.docCptClient.ville != null) { change = true; this.docCptClient.ville = null }
    //                if (this.docCptClient.cedex != null) { change = true; this.docCptClient.cedex = null }
    //                if (this.docCptClient.pays != null) { change = true; this.docCptClient.pays = null }
    //            } else {
    //                //var adrLib = ""
    //                //if (typeof adr.ad1 != 'undefined' && adr.ad1 != null && adr.ad1.length > 0) adrLib = adr.ad1
    //                //if (typeof adr.ad2 != 'undefined' && adr.ad2 != null && adr.ad2.length > 0) adrLib = ((typeof adr.ad2 != 'undefined' && adr.ad2 != null && adrLib.length > 0) ? ", " : "") + adr.ad2
    //                //if (typeof adr.ad3 != 'undefined' && adr.ad3 != null && adr.ad3.length > 0) adrLib = ((typeof adr.ad3 != 'undefined' && adr.ad3 != null && adrLib.length > 0) ? ", " : "") + adr.ad3
    //                //if (this.docCptClient.ad1 != ((adrLib.length == 0) ? null : adrLib)) { change = true; this.docCptClient.ad1 = ((adrLib.length == 0) ? null : adrLib) }
    //                if (this.docCptClient.ad1 != adr.ad1) { change = true; this.docCptClient.ad1 = adr.ad1 }
    //                if (this.docCptClient.ad2 != adr.ad2) { change = true; this.docCptClient.ad2 = adr.ad2 }
    //                if (this.docCptClient.ad3 != adr.ad3) { change = true; this.docCptClient.ad3 = adr.ad3 }
    //                if (this.docCptClient.cp != ((typeof adr.cp == 'undefined' || adr.cp == null || adr.cp.length == 0) ? null : adr.cp)) { change = true; this.docCptClient.cp = ((typeof adr.cp == 'undefined' || adr.cp == null || adr.cp.length == 0) ? null : adr.cp) }
    //                var villeCedex = ((typeof adr.ville != 'undefined' && adr.ville != null) ? adr.ville : "") + ((typeof adr.cedex != 'undefined' && adr.cedex != null && adr.cedex.length > 0) ? " " + adr.cedex : "")
    //                if (this.docCptClient.ville != ((villeCedex.length == 0) ? null : villeCedex)) {
    //                    change = true; this.docCptClient.ville = ((villeCedex.length == 0) ? null : villeCedex)
    //                }
    //                if (this.docCptClient.pays != ((typeof adr.pays == 'undefined' || adr.pays == null || adr.pays.length == 0) ? null : adr.pays)) { change = true; this.docCptClient.pays = ((typeof adr.pays == 'undefined' || adr.pays == null || adr.pays.length == 0) ? null : adr.pays) }
    //            }
    //            //var email = objClient.objetMetier.mGetAdresseEmailDefaut()
    //            var email = clDataTemp.mGetAdresseEmailDefaut()
    //            if (email == null) {
    //                if (this.docCptClient.adresse_email != null) { change = true; this.docCptClient.adresse_email = null }
    //            } else {
    //                if (this.docCptClient.adresse_email != email) { change = true; this.docCptClient.adresse_email = email }
    //            }
    //            if (objClient.mGetTable().nom == "structures" || objClient.mGetTable().nom == "structures_contact") {
    //                if (objClient.mGetTable().nom == "structures_contact") {
    //                    objClient = bddRef.getObjet(objClient.objetMetier.mGetDataStructures())
    //                    clDataTemp = new cDataTemplateStrCon(bddRef, objClient.mGetTable().id_table, objClient.cle())
    //                }
    //                if (clDataTemp.mGetTvaIntra() == null) {
    //                    if (this.docCptClient.tva_intra != null) { change = true; this.docCptClient.tva_intra = null }
    //                } else {
    //                    if (this.docCptClient.tva_intra != clDataTemp.mGetTvaIntra()) { change = true; this.docCptClient.tva_intra = clDataTemp.mGetTvaIntra() }
    //                }
    //                if (clDataTemp.mGetSiret() == null) {
    //                    if (this.docCptClient.siret != null) { change = true; this.docCptClient.siret = null }
    //                } else {
    //                    if (this.docCptClient.siret != clDataTemp.mGetTvaIntra()) { change = true; this.docCptClient.siret = clDataTemp.mGetTvaIntra() }
    //                }
    //                //var champTableData = objClient.objetMetier.mGetLstChampTableData()
    //                //champTableData = champTableData.filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_tvaintra })[0]
    //                //if (typeof champTableData == "undefined" || champTableData.valeur == null || champTableData.valeur.length == 0) {
    //                //    if (this.docCptClient.tva_intra != null) { change = true; this.docCptClient.tva_intra = null }
    //                //} else {
    //                //    if (this.docCptClient.tva_intra != champTableData.valeur) { change = true; this.docCptClient.tva_intra = champTableData.valeur }
    //                //}
    //            }
    //        }
    //    }
    //    return change
    //}

    //return true si update
    this.mUpdateDocCptSociete = function (dataSociete) {
        var objSociete = null
        if (typeof dataSociete == 'undefined' || dataSociete == null) { objSociete = bddRef.getObjet("societe", this.docCptSociete.id_societe) }
        else { objSociete = bddRef.getObjet(dataSociete) }
        var change = false
        for (var prop in this.docCptSociete) {
            if (typeof objSociete.data[prop] != 'undefined' && objSociete.data[prop] != Me.docCptSociete[prop]) {
                Me.docCptSociete[prop] = objSociete.data[prop]
                change = true
            }
        }
        //this.mGetLogoSociete(function () {
        //    Me.mRecalculLigneDetail()
        //    funcOk(change)
        //})

    }

    this.mGetLstResumeTva = function () {
        var lstResumeTva = []
        this.docCptLigne.forEach(function (lig) {
            if (lig.id_tva != null) {
                var tvaResume = lstResumeTva.filter(function (o) { return o.id_tva == lig.id_tva })[0]
                if (typeof tvaResume == 'undefined') {
                    tvaResume = {
                        id_tva: lig.id_tva,
                        nom: lig.nom_tva,
                        taux: parseFloat(lig.taux_tva),
                        mt: 0
                    }
                    lstResumeTva.push(tvaResume)
                }
                tvaResume.mt += parseFloat(lig.tottva_avec_remise_pied)
            }
        })
        return lstResumeTva.sort(function (o1, o2) { return o1.taux - o2.taux })
    }

    this.mHasRemiseLigne = function () {
        return this.docCptLigne.filter(function (ligne) { return ligne.type_remise != 0 }).length > 0
    }

    this.mRecalculLigneDetail = function () {
        if (this.docCpt.id_statut_com == "1") {
            //on recalcul les lignes 
            this.docCptLigne.forEach(function (ligne) {
                var tva = bddRef.getObjet("tva", ligne.id_tva)
                ligne.taux_tva = ((typeof tva.data == 'undefined') ? 0 : tva.data.taux)
                ligne.nom_tva = ((typeof tva.data == 'undefined') ? "" : tva.data.nom)
                if (typeof tva.data == 'undefined' || (!Me.isSocieteAssujettiTva() && !Me.isDocumentAssujettiTva())) {
                    ligne.puttc = parseFloat(ligne.puht).toFixed4()
                } else {
                    ligne.puttc = (Math.round((parseFloat(ligne.puht) + parseFloat(ligne.puht) * tva.objetMetier.mGetTauxTva() / 100) * 100) / 100).toFixed2()
                }

                //mode_ttc toujours à 0 (pas géré en parametrage)
                if (Me.isSocieteAssujettiTva() && Me.isDocumentAssujettiTva()) {
                    if (Me.docCptSociete.mode_ttc == "1") {
                        ligne.totttc_sans_remise = (parseFloat(ligne.puttc) * parseFloat(ligne.qte)).toFixed2()
                        ligne.tottva_sans_remise = (parseFloat(ligne.totttc_sans_remise) - parseFloat(ligne.totttc_sans_remise) / (1 + tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                        ligne.totht_sans_remise = (parseFloat(ligne.totttc_sans_remise) - ligne.tottva_sans_remise).toFixed2()
                    } else {
                        ligne.totht_sans_remise = (parseFloat(ligne.puht) * parseFloat(ligne.qte)).toFixed4()
                        ligne.tottva_sans_remise = (parseFloat(ligne.totht_sans_remise) * tva.objetMetier.mGetTauxTva() / 100).toFixed2()
                        ligne.totttc_sans_remise = (parseFloat(ligne.totht_sans_remise) + ligne.tottva_sans_remise).toFixed2()
                    }
                } else {
                    ligne.totht_sans_remise = (parseFloat(ligne.puht) * parseFloat(ligne.qte)).toFixed4()
                    ligne.tottva_sans_remise = 0
                    ligne.totttc_sans_remise = (parseFloat(ligne.totht_sans_remise) + ligne.tottva_sans_remise).toFixed2()
                }
                //Calcul from ht
                switch (parseInt(ligne.type_remise)) {
                    case 0: //aucune remise
                        ligne.totht_sans_remise_pied = ligne.totht_sans_remise;
                        break;
                    case 1: //pourcentage
                        ligne.taux_remise = ligne.taux_mt_remise
                        ligne.mt_remise_ht = (ligne.totht_sans_remise * (ligne.taux_mt_remise / 100)).toFixed2()
                        ligne.totht_sans_remise_pied = (ligne.totht_sans_remise - ligne.mt_remise_ht).toFixed2()
                        break;
                    case 2: //montant
                        ligne.taux_remise = (ligne.taux_mt_remise / ligne.totht_sans_remise * 100).toFixed2()
                        ligne.mt_remise_ht = ligne.taux_mt_remise
                        ligne.totht_sans_remise_pied = (ligne.totht_sans_remise - ligne.taux_mt_remise).toFixed2()
                        break;
                }
                ligne.tottva_sans_remise_pied = 0
                if (Me.isSocieteAssujettiTva() && Me.isDocumentAssujettiTva()) {
                    ligne.tottva_sans_remise_pied = (parseFloat(ligne.totht_sans_remise_pied) * (tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                }
                ligne.totttc_sans_remise_pied = (ligne.totht_sans_remise_pied + ligne.tottva_sans_remise_pied).toFixed2()
                ligne.mt_remise_ttc = ligne.totttc_sans_remise_pied - ligne.totttc_sans_remise
                //calcul from ttc
                //switch (parseInt(ligne.type_remise)) {
                //    case 0: //aucune remise
                //        ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise;
                //        break;
                //    case 1: //pourcentage
                //        ligne.taux_remise = ligne.taux_mt_remise
                //        ligne.mt_remise_ttc = (ligne.totttc_sans_remise * (ligne.taux_mt_remise / 100)).toFixed2()
                //        ligne.totttc_sans_remise_pied = (ligne.totttc_sans_remise - ligne.mt_remise_ttc).toFixed2()
                //        break;
                //    case 2: //montant
                //        ligne.taux_remise = (ligne.taux_mt_remise / ligne.totttc_sans_remise * 100).toFixed2()
                //        ligne.mt_remise_ttc = ligne.taux_mt_remise
                //        ligne.totttc_sans_remise_pied = (ligne.totttc_sans_remise - ligne.taux_mt_remise).toFixed2()
                //        break;
                //}
                //ligne.tottva_sans_remise_pied = (ligne.totttc_sans_remise_pied - parseFloat(ligne.totttc_sans_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                //ligne.totht_sans_remise_pied = (ligne.totttc_sans_remise_pied - ligne.tottva_sans_remise_pied).toFixed2()
                //ligne.mt_remise_ht = ligne.totht_sans_remise - ligne.totht_sans_remise_pied
            })

            this.docCpt.nb_ligne_vente = this.docCptLigne.length;

            this.docCptLigne.forEach(function (lig) {
                if (lig.nom_article == null) {
                    var obj = bddRef.getObjet("article", lig.id_article)
                    lig.nom_article = ((obj.data.nom == null) ? "" : obj.data.nom)
                }
            })


            this.docCpt.totht_sans_remise = 0
            this.docCpt.tottva_sans_remise = 0
            this.docCpt.totttc_sans_remise = 0
            this.docCptLigne.forEach(function (lig) {
                Me.docCpt.totht_sans_remise += parseFloat(lig.totht_sans_remise)
                Me.docCpt.tottva_sans_remise += parseFloat(lig.tottva_sans_remise)
                Me.docCpt.totttc_sans_remise += parseFloat(lig.totttc_sans_remise)
            })
            this.docCpt.totht_sans_remise = parseFloat(this.docCpt.totht_sans_remise).toFixed2()
            this.docCpt.tottva_sans_remise = parseFloat(this.docCpt.tottva_sans_remise).toFixed2()
            this.docCpt.totttc_sans_remise = parseFloat(this.docCpt.totttc_sans_remise).toFixed2()

            //dispatch TVA & remise pied
            this.docCpt.totht_sans_remise_pied = 0
            this.docCpt.tottva_sans_remise_pied = 0
            this.docCpt.totttc_sans_remise_pied = 0
            this.docCpt.totht_avec_remise_pied = 0
            this.docCpt.tottva_avec_remise_pied = 0
            this.docCpt.totttc_avec_remise_pied = 0
            if (this.docCpt.type_remise == 0) {
                this.docCptLigne.forEach(function (lig) {
                    lig.totht_avec_remise_pied = parseFloat(lig.totht_sans_remise_pied).toFixed2()
                    lig.tottva_avec_remise_pied = parseFloat(lig.tottva_sans_remise_pied).toFixed2()
                    lig.totttc_avec_remise_pied = (parseFloat(lig.totht_avec_remise_pied) + parseFloat(lig.tottva_avec_remise_pied)).toFixed2()
                    Me.docCpt.totht_sans_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                    Me.docCpt.tottva_sans_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                    Me.docCpt.totttc_sans_remise_pied += parseFloat(lig.totttc_avec_remise_pied)

                    Me.docCpt.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                    Me.docCpt.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                    Me.docCpt.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
                })
            } else {
                this.docCptLigne.forEach(function (lig) {
                    Me.docCpt.totht_sans_remise_pied += parseFloat(lig.totht_sans_remise_pied).toFixed2()
                    Me.docCpt.tottva_sans_remise_pied += parseFloat(lig.tottva_sans_remise_pied).toFixed2()
                    Me.docCpt.totttc_sans_remise_pied += parseFloat(lig.totttc_sans_remise_pied).toFixed2()
                })
                //Calcul remise pied sur HT
                var mtRemisePiedHt = 0
                if (this.docCpt.type_remise == 1) {
                    mtRemisePiedHt = (parseFloat(this.docCpt.totht_sans_remise_pied) * this.docCpt.taux_mt_remise / 100).toFixed2()
                    this.docCpt.taux_remise = this.docCpt.taux_mt_remise
                    this.docCpt.mt_remise_ht = mtRemisePiedHt
                } else {
                    mtRemisePiedHt = ((this.docCpt.taux_mt_remise == null) ? 0 : this.docCpt.taux_mt_remise)
                    this.docCpt.taux_remise = (parseFloat(this.docCpt.totht_sans_remise_pied) / this.docCpt.taux_mt_remise * 100).toFixed2()
                    this.docCpt.mt_remise_ht = this.docCpt.taux_mt_remise
                }
                var relicat = ((mtRemisePiedHt) ? mtRemisePiedHt : 0)
                this.docCptLigne.forEach(function (lig) {
                    var partRemisePied = 0
                    if (parseFloat(Me.docCpt.totht_sans_remise_pied) != 0) {
                        partRemisePied = Math.round(mtRemisePiedHt / parseFloat(Me.docCpt.totht_sans_remise_pied) * lig.totht_sans_remise_pied * 100) / 100
                    }
                    lig.totht_avec_remise_pied = (lig.totht_sans_remise_pied - partRemisePied).toFixed2()
                    if (lig.id_tva != null) {
                        var tva = bddRef.getObjet("tva", lig.id_tva)
                        //ligne.tottva_sans_remise_pied = (parseFloat(ligne.totht_sans_remise_pied) * (tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                        lig.tottva_avec_remise_pied = (lig.totht_avec_remise_pied * (tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                        lig.totttc_avec_remise_pied = (lig.totht_avec_remise_pied + lig.tottva_avec_remise_pied).toFixed2()
                    } else {
                        lig.tottva_avec_remise_pied = 0
                        lig.totttc_avec_remise_pied = lig.totht_avec_remise_pied
                    }
                    relicat -= partRemisePied
                })
                relicat = Math.round(relicat * 100) / 100
                var idx = 0
                while (relicat != 0) {
                    idx += 1
                    if (idx == 1000) {
                        debugger;
                        break;
                    }
                    Me.docCptLigne.forEach(function (lig) {
                        if (relicat != 0) {
                            var enleve = -0.01
                            if (relicat < 0) enleve = 0.01
                            Me.docCpt.totht_avec_remise_pied += enleve
                            relicat += enleve
                            relicat = Math.round(relicat * 100) / 100
                        }
                    })
                }
                //on recalcul les TVA aprés avoir dispatché la remise pied
                this.docCptLigne.forEach(function (lig) {
                    if (lig.id_tva != null) {
                        var tva = bddRef.getObjet("tva", lig.id_tva)
                        lig.tottva_avec_remise_pied = 0
                        if (Me.isSocieteAssujettiTva() && Me.isDocumentAssujettiTva()) {
                            lig.tottva_avec_remise_pied = (lig.totht_avec_remise_pied * (tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                        }
                        //lig.tottva_avec_remise_pied = (lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                        lig.totttc_avec_remise_pied = (lig.totht_avec_remise_pied + lig.tottva_avec_remise_pied).toFixed2()
                    } else {
                        lig.tottva_avec_remise_pied = 0
                        lig.totttc_avec_remise_pied = lig.totht_avec_remise_pied
                    }
                })
                this.docCptLigne.forEach(function (lig) {
                    Me.docCpt.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                    Me.docCpt.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                    Me.docCpt.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
                })
                this.docCpt.mt_remise_ttc = this.docCpt.totttc_sans_remise_pied - this.docCpt.totttc_avec_remise_pied
                //calcul remise pied sur TTC
                //var mtRemisePiedTtc = 0
                //if (this.docCpt.type_remise == 1) {
                //    mtRemisePiedTtc = (parseFloat(this.docCpt.totttc_sans_remise_pied) * this.docCpt.taux_mt_remise / 100).toFixed2()
                //    this.docCpt.taux_remise = this.docCpt.taux_mt_remise
                //    this.docCpt.mt_remise_ttc = mtRemisePiedTtc
                //} else {
                //    mtRemisePiedTtc = ((this.docCpt.taux_mt_remise == null) ? 0 : this.docCpt.taux_mt_remise)
                //    this.docCpt.taux_remise = (parseFloat(this.docCpt.totttc_sans_remise_pied) / this.docCpt.taux_mt_remise * 100).toFixed2()
                //    this.docCpt.mt_remise_ttc = this.docCpt.taux_mt_remise
                //}
                //var relicat = ((mtRemisePiedTtc) ? mtRemisePiedTtc : 0)
                //this.docCptLigne.forEach(function (lig) {
                //    var partRemisePied = 0
                //    if (parseFloat(Me.docCpt.totht_sans_remise) != 0) {
                //        partRemisePied = Math.round(mtRemisePiedTtc / parseFloat(Me.docCpt.totht_sans_remise) * lig.totht_sans_remise_pied * 100) / 100
                //    }
                //    lig.totttc_avec_remise_pied = (lig.totttc_sans_remise_pied - partRemisePied).toFixed2()
                //    if (lig.id_tva != null) {
                //        var tva = bddRef.getObjet("tva", lig.id_tva)
                //        lig.tottva_avec_remise_pied = (lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                //        lig.totht_avec_remise_pied = (lig.totttc_avec_remise_pied - lig.tottva_avec_remise_pied).toFixed2()
                //    } else {
                //        lig.tottva_avec_remise_pied = 0
                //        lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied
                //    }
                //    relicat -= partRemisePied
                //})
                //relicat = Math.round(relicat * 100) / 100
                //var idx = 0
                //while (relicat != 0) {
                //    idx += 1
                //    if (idx == 1000) {
                //        debugger;
                //        break;
                //    }
                //    Me.docCptLigne.forEach(function (lig) {
                //        if (relicat != 0) {
                //            var enleve = -0.01
                //            if (relicat < 0) enleve = 0.01
                //            Me.docCpt.totttc_avec_remise_pied += enleve
                //            relicat += enleve
                //            relicat = Math.round(relicat * 100) / 100
                //        }
                //    })
                //}
                ////on recalcul les TVA aprés avoir dispatché la remise pied
                //this.docCptLigne.forEach(function (lig) {
                //    if (lig.id_tva != null) {
                //        var tva = bddRef.getObjet("tva", lig.id_tva)
                //        lig.tottva_avec_remise_pied = (lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)).toFixed2()
                //        lig.totht_avec_remise_pied = (lig.totttc_avec_remise_pied - lig.tottva_avec_remise_pied).toFixed4()
                //    } else {
                //        lig.tottva_avec_remise_pied = 0
                //        lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied
                //    }
                //})
                //this.docCptLigne.forEach(function (lig) {
                //    Me.docCpt.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                //    Me.docCpt.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                //    Me.docCpt.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
                //})
                //this.docCpt.mt_remise_ht = this.docCpt.totht_sans_remise_pied - this.docCpt.totht_avec_remise_pied
            }

            this.docCpt.totht_sans_remise_pied = parseFloat(this.docCpt.totht_sans_remise_pied).toFixed4()
            this.docCpt.tottva_sans_remise_pied = parseFloat(this.docCpt.tottva_sans_remise_pied).toFixed2()
            this.docCpt.totttc_sans_remise_pied = parseFloat(this.docCpt.totttc_sans_remise_pied).toFixed2()

            this.docCpt.totht_avec_remise_pied = parseFloat(this.docCpt.totht_avec_remise_pied).toFixed4()
            this.docCpt.tottva_avec_remise_pied = parseFloat(this.docCpt.tottva_avec_remise_pied).toFixed2()
            this.docCpt.totttc_avec_remise_pied = parseFloat(this.docCpt.totttc_avec_remise_pied).toFixed2()

            this.docCpt.totttc_avec_remise_pied = (Math.round(parseFloat(this.docCpt.totttc_avec_remise_pied) * 100) / 100).toFixed2()
        }

        var resteAPayer = this.docCpt.totttc_avec_remise_pied.toFixed2()
        this.docCptModeReglement.forEach(function (reg) {
            resteAPayer = resteAPayer - reg.mt.toFixed2()
        })
        this.docCpt.reste_a_payer = resteAPayer.toFixed2()
    }

    this.mSaveDocCptClient = function (update, funcOk, funcKo) {
        //if (update) this.mUpdateDocCptClient()
        this.mSave(funcOk, null, funcKo, [], [], 2)
        //bddRef.getObjet(this.docCptClient).mSave(function (data) {

        //    if (typeof funcOk != 'undefined') funcOk()
        //})
    }

    this.mGetUrlCgv = function () {
        if (this.docCpt.id_cgv != null) {
            var urlCgv = parametre.url_appli + "/" + this.docCpt.nom_base + "/" + this.docCpt.id_cgv + "/cgv"
            return urlCgv
        } else { return "" }
    }

    this.mGetOrdreCheque = function () {
        var objSoc = this.mGetObjetSocieteRef()
        if (objSoc.data.ordre_cheque != null && objSoc.data.ordre_cheque.length > 0) { return objSoc.data.ordre_cheque }
        else { return objSoc.data.nom }
    }

    this.mGetAdresseSociete = function () {
        var objSoc = this.mGetObjetSocieteRef()
        return objSoc.data.nom + " &bull; " + objSoc.data.ad1 + " &bull; " + (objSoc.data.ad2 ? objSoc.data.ad2 + " &bull; " : "") + (objSoc.data.ad3 ? objSoc.data.ad3 + " &bull; " : "") + objSoc.data.cp + " " + objSoc.data.ville + " &bull; " + objSoc.data.pays
    }

    //lstDocCptModeRegToDel pas utilisé, prévu au cas ou
    this.mSave = function (funcOk, funcAlways, funcKo, lstDocCptLigneToDel = [], lstDocCptModeRegToDel = [], idTypeAction = 0) {
        if (!funcKo) {
            debugger
            try {
                throw new Error("Sauvegarde doccptdetail sans gestion d'erreur")
            } catch (e) {
                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
            }
        }
        this.docCpt.lock_id_utilisateur = bddRef.utiCourant.id_utilisateur
        this.docCpt.lock_date_utilisateur = parametre.dateNow
        this.docCpt.dmo = parametre.dateNow
        var lstData = [this.docCpt]
        if (this.docCpt.id_statut_com != "2") this.docCptLigne.forEach(function (lig) { lstData.push(lig) })
        this.docCptModeReglement.forEach(function (ligReg) { lstData.push(ligReg) })
        if (this.docCpt.id_statut_com != "2") {
            this.mUpdateDocCptSociete(null)
            lstData.push(Me.docCptSociete)
            //Me.mUpdateDocCptClient()
            lstData.push(Me.docCptClient)
        }
        var objs = bddRef.getObjets()
        objs.idTableRef = bddRef.table.mGetItemFromNom("doc_cpt").id_table
        objs.idRef = this.docCpt.id_doc_cpt
        objs.id_type_action = idTypeAction
        objs.save_historique = 0
        objs.mAddData(lstData, "save")
        if (lstDocCptLigneToDel.length > 0) objs.mAddData(lstDocCptLigneToDel, "suppdef")
        objs.mSave(funcOk, funcAlways, function (data) {
            if (funcKo) {
                mGereLock(data)
                funcKo()
            }
        })
    }

    function mGereLock(data) {
        if (data && (data.erreur_objets || data.id_uti_encours != bddRef.utiCourant.id_utilisateur)) {
            //on une erreur géré
            //lock
            //id_uti_encours
            //dat_lock
            var objUti = bddRef.getObjet("utilisateur", data.id_uti_encours)
            if (data.lock == "1") {
                var elapsedSec = Math.floor((new Date(data.dat_server) - new Date(data.dat_lock)) / 1000);
                var remainingSec = Math.max(0, data.timeoutSeconds - elapsedSec);
                var minutes = Math.floor(remainingSec / 60);
                var secondes = remainingSec % 60;
                var resultat = (minutes > 0 ? minutes + " minute" + (minutes > 1 ? "s" : "") : "") + (minutes > 0 && secondes > 0 ? " et " : "") + (secondes > 0 ? secondes + " seconde" + (secondes > 1 ? "s" : "") : "");
                mNotify("Le document est bloqué par <b>" + objUti.mGetLib1() + "</b> qui est entrain de le modifier.<br/>votre modification a été annulée.<br/>Veuillez réessayer d'ici " + resultat, "error", 20000)
            } else {
                mNotify("Le document a été modifié par <b>" + objUti.mGetLib1() + "</b>.<br/>votre modification a été annulée.<br/>Veuillez réessayer.", "error", 20000)
            }
        } else {
            //plantage
            mNotify("Erreur durant le calcul du document", "error", 6000)
        }
        $("body").find(".dx-ctrljauge").each(function () {
            var jauge = $(this).getInstance()
            jauge.mHide();
        })
    }

    this.mValideDocument = function (idTypeComCible, funcOk, funcKo) {

        var lstModeRegCmdDevis = this.docCptModeReglement.filter(function (modeReg) {
            return modeReg.id_mode_reglement == 11 || modeReg.id_mode_reglement == 12
        })
        if (lstModeRegCmdDevis.length > 0) {
            mVerifDocDevisCmd(0)
            function mVerifDocDevisCmd(idx) {
                if (typeof lstModeRegCmdDevis[idx] == 'undefined') { mValide() }
                else {
                    var docCpt = bddRef.getObjet("doc_cpt", lstModeRegCmdDevis[idx].id_doc_cpt_source)
                    if (docCpt.id_doc_cpt_facture_valide != null) {
                        jaugeDemarrage.mHide()
                        mNotify("Vous ne pouvez pas valider ce document, le règlement lié à un devis/commande à déjà été utilisé.<br/>Supprimer le règlement correspondant pour pouvoir valider le document.", "error", 8000)
                    } else { mVerifDocDevisCmd(idx + 1) }
                }
            }
        } else { mValide() }

        function mValide() {
            Me.docCpt.id_cgv = null
            var dataCgv = bddRef.getObjet("societe", Me.docCpt.id_societe).objetMetier.mGetCgvEnCours()
            if (dataCgv) Me.docCpt.id_cgv = dataCgv.id_cgv

            Me.mRecalculLigneDetail()
            //Me.mUpdateDocCptClient()
            Me.mUpdateDocCptSociete(null)
            Me.mSave(function () {
                var htmlDetail = Me.mGetHmlEtHtmlPiedOriginal("a4", true)
                bddRef.mAjaxCall({
                    command: "validedoccpt2",
                    id_doc_cpt: Me.docCpt.id_doc_cpt,
                    id_type_com_cible: idTypeComCible,
                    html: htmlDetail.body,
                    html_pied: htmlDetail.pied
                }, function (data) {
                    (new cDocCptDetail(bddRef)).mGetDocCptDetail(bddRef, Me.docCpt.id_doc_cpt, function (docCptDetail) {
                        Me.mReset(docCptDetail.mGetDataDocCptDetail(), function () {
                            var lstAction = [{ nomTableAction: "doc_cpt", action: "modif", itemData: docCptDetail.docCpt }]
                            bddRef.triggerFunctionOnModifiedItemDataWithTempo(lstAction, 200)

                            funcOk()
                        })
                    })
                }, null, function (data) {
                    $("body").find(".dx-ctrljauge").each(function () {
                        var jauge = $(this).getInstance()
                        jauge.mHide();
                    })
                    mNotify("Impossible de valider le document", "error", 10000)
                })
            }, null, funcKo, [], [], 21)


        }
    }

    //this.mSendEmailAvecDocCpt = function (adresseEmail, open) {
    //    if (typeof open == 'undefined') open = false
    //    var lstdest = mGetLstDest().filter(function (ema) { return ema.adresse_email.length > 0 })
    //    bddRef.getObjet("com_email_envoi").objetMetier.mCreateEmailBrouillon("", "", [], lstdest, bddRef.paraInvitto.mGetModeleEmailConfirmResaDemandeArrhes(), true, objet.data.id_booking, true, null, false, "", function (idComEmailEnvoi) {
    //        if (open) { bddRef.getObjet("com_email_envoi", idComEmailEnvoi).mShowPopup() }
    //        else { bddRef.getObjet("com_email_envoi", idComEmailEnvoi).objetMetier.mSendImmediatement() }
    //    })
    //}

    this.mGetDuplicata = function (nombase, funcOk) {
        var dataToBeSent = {
            command: "getdoccptduplicata",
            id_doc_cpt: this.docCpt.id_doc_cpt,
            nombase: ((nombase != null) ? nombase : bddRef.nom_base)
        }
        bddRef.mAjaxCall(dataToBeSent, function (data) {
            Me.docCpt = data.doc_cpt
            if (typeof data.doc_cpt_duplicata == 'undefined') data.doc_cpt_duplicata = []
            funcOk(data.doc_cpt_duplicata[0])
            var lstAction = [{ nomTableAction: "doc_cpt", action: "modif", itemData: Me.docCpt }]
            bddRef.triggerFunctionOnModifiedItemDataWithTempo(lstAction, 200)
        }, function () {
        }, function () { jaugeDemarrage.mHide(); mNotify("Impossible d'imprimer le document", "error", 5000) });
    }

    this.mReloadModeReglement = function (funcOk) {
        this.docCptModeReglement = dataDocCptDetail.docCptModeReglement
        bddRef.mAjaxCall({ command: "getdatasdoccptmodereglement", id: Me.docCpt.id_doc_cpt }, function (data) {
            data.doc_cpt_mode_reglement = JSON.parse(data.doc_cpt_mode_reglement)
            //if (typeof data.doc_cpt_mode_reglement == 'undefined') data.doc_cpt_mode_reglement = []
            debugger
            Me.docCptModeReglement = data.doc_cpt_mode_reglement
            if (typeof funcOk != 'undefined') funcOk()
        })
    }

    this.mClearLigne = function (funcEnd, funcKo) {
        mDel()
        function mDel() {
            if (Me.docCptLigne.length > 0) {
                var lig = Me.docCptLigne[Me.docCptLigne.length - 1]
                bddRef.getObjet(lig).mDelDataDefinitif(function () {
                    Me.docCptLigne.splice(Me.docCptLigne.indexOf(lig), 1)
                    mDel()
                })
            } else {
                Me.mRecalculLigneDetail()
                Me.mSave(function () { funcEnd() }, null, funcKo, [], [], 22)
            }
        }
    }

    this.mAnnuleDocCpt = function (valideAnnuleDoc, funcOk) {
        this.mTransforme(true, valideAnnuleDoc, funcOk, false)
    }
    this.mTransformeAnnuleEtNew = function (idTypeComNewDoc, valideNewDoc, newDocCptClient, funcOk) {
        this.mTransforme(true, true, null, true, idTypeComNewDoc, valideNewDoc, newDocCptClient, funcOk)
    }
    this.mTransformeNew = function (idTypeComNewDoc, valideNewDoc, funcOk) {
        this.mTransforme(false, null, null, true, idTypeComNewDoc, valideNewDoc, null, funcOk)
    }
    //A partir d'un document
    //Génère un ne doc qui annule le doc si annuleDoc = true
    //Générer un nouveau document si creeNew = true sur idTypeCom/idStatutCom
    //return en 1 docCptDetailNegatif
    //return en 2 le noveau document généré
    this.mTransforme = function (annuleDoc, valideAnnuleDoc, funcOkAnnule, creeNewDoc, idTypeComNewDoc, valideNewDoc, newDocCptClient, funcOkNew) {
        Me.docCpt.id_mode_reglement_attendu = null
        bddRef.getObjet(Me.docCpt).mSaveChamp("id_mode_reglement_attendu")
        debugger
        var dataToBeSent = {
            command: "savemultidoccpt"
        }
        if (annuleDoc) {
            var docCptTicketAnnule = Me.mCloneDocCpt()
            docCptTicketAnnule.mRemoveId()

            docCptTicketAnnule.docCptModeReglement = []
            docCptTicketAnnule.docCptAvoir = []

            docCptTicketAnnule.docCpt.nb_impression = 0
            //docCptTicketAnnule.docCpt.id_document = null
            //docCptTicketAnnule.docCpt.date_document = null
            //docCptTicketAnnule.docCpt.id_doc_cpt_facture_valide = null
            //docCptTicketAnnule.docCpt.id_doc_cpt_cmde_devis_valide = null
            //docCptTicketAnnule.docCpt.signature = null
            //docCptTicketAnnule.docCpt.signature_display = null
            //docCptTicketAnnule.docCpt.grand_totaux_algebrique = null
            //docCptTicketAnnule.docCpt.grand_totaux_absolu = null
            //docCptTicketAnnule.docCpt.signature_grand_totaux = null
            //docCptTicketAnnule.docCpt.id_doc_cpt_totaux_document = null
            //docCptTicketAnnule.docCpt.signature_avant = null
            //docCptTicketAnnule.docCpt.id_doc_cpt_source_avoir = Me.docCpt.id_doc_cpt
            docCptTicketAnnule.docCpt.type_operation = "avoir"

            var lstChamp = ["nb_impression", "id_document", "date_document", "id_doc_cpt_facture_valide", "id_doc_cpt_cmde_devis_valide", "signature", "signature_display", "grand_totaux_algebrique", "grand_totaux_absolu", "signature_grand_totaux", "id_doc_cpt_totaux_document", "signature_avant", "id_doc_cpt_source_avoir", "entete_document_valide", "facturx_id_pa", "facturx_id_statut", "facturx_statut", "facturx_date_envoi", "facturx_date_dernier_statut", "facturx_dernier_message_erreur", "facturx_html", "facturx_html_pied", "facturx_erreur_envoi", "facturx_envoi_abandonne", "facturx_ereporting_declare", "facturx_id_statut_vu", "last_dmo_facturx_statut", "facturx_encaisse_b2bint", "dernier_lst_code_motif", "facturx_ppf_ereporting_id", "dans_circuit_envoi_pa"]
            lstChamp.forEach(function (nomChamp) { docCptTicketAnnule.docCpt[nomChamp] = null })

            docCptTicketAnnule.docCpt.nb_impression = 0
            docCptTicketAnnule.docCptLigne.forEach(function (lig) {
                lig.qte = -lig.qte
            })
            docCptTicketAnnule.docCptModeReglement.forEach(function (modeReg) {
                modeReg.mt = -modeReg.mt
            })
            docCptTicketAnnule.docCpt.id_statut_com = "1"

            docCptTicketAnnule.mRecalculLigneDetail()

            dataToBeSent.data_annule = docCptTicketAnnule.mGetDataDocCptDetail()
            dataToBeSent.valide_annule = ((valideAnnuleDoc) ? "1" : "0")

            if (dataToBeSent.valide_annule == "1") {
                var htmlDetail = docCptTicketAnnule.mGetHmlEtHtmlPiedOriginal("a4", true)
                dataToBeSent.html_annule = htmlDetail.body
                dataToBeSent.html_pied_annule = htmlDetail.pied
            }

            dataToBeSent.id_doc_cpt_annule = Me.docCpt.id_doc_cpt
        }

        if (creeNewDoc) {
            var docCptNew = Me.mCloneDocCpt()
            docCptNew.mRemoveId()
            //docCptNew.docCpt.nb_impression = 0
            docCptNew.docCpt.id_type_com = idTypeComNewDoc
            docCptNew.docCpt.id_statut_com = "1"
            //docCptNew.docCpt.id_document = null
            //docCptNew.docCpt.date_document = null
            //docCptNew.docCpt.id_doc_cpt_facture_valide = null
            //docCptNew.docCpt.id_doc_cpt_cmde_devis_valide = null
            //docCptNew.docCpt.signature = null
            //docCptNew.docCpt.signature_display = null
            //docCptNew.docCpt.grand_totaux_algebrique = null
            //docCptNew.docCpt.grand_totaux_absolu = null
            //docCptNew.docCpt.signature_grand_totaux = null
            //docCptNew.docCpt.id_doc_cpt_totaux_document = null
            //docCptNew.docCpt.signature_avant = null

            var lstChamp = ["id_document", "date_document", "id_doc_cpt_facture_valide", "id_doc_cpt_cmde_devis_valide", "signature", "signature_display", "grand_totaux_algebrique", "grand_totaux_absolu", "signature_grand_totaux", "id_doc_cpt_totaux_document", "signature_avant", "id_doc_cpt_source_avoir", "entete_document_valide", "facturx_id_pa", "facturx_id_statut", "facturx_statut", "facturx_date_envoi", "facturx_date_dernier_statut", "facturx_dernier_message_erreur", "facturx_html", "facturx_html_pied", "facturx_erreur_envoi", "facturx_envoi_abandonne", "facturx_ereporting_declare", "facturx_id_statut_vu", "last_dmo_facturx_statut", "facturx_encaisse_b2bint", "dernier_lst_code_motif", "facturx_ppf_ereporting_id", "dans_circuit_envoi_pa"]
            lstChamp.forEach(function (nomChamp) { docCptNew.docCpt[nomChamp] = null })


            dataToBeSent.valide_new = ((valideNewDoc) ? "1" : "0")
            if (dataToBeSent.valide_new == "1") {
                //on rajoute les modes de reglements du document annulé (pour bien calculer le reste à payer)
                docCptNew.docCptModeReglement = Me.docCptModeReglement
            }
            docCptNew.mRecalculLigneDetail()
            docCptNew.docCptModeReglement = []

            if (newDocCptClient) {
                newDocCptClient.id_doc_cpt_client = null
                docCptNew.docCptClient = newDocCptClient
            }

            //dataToBeSent.doc_cpt_mode_reglement_to_del = Me.docCptModeReglement

            dataToBeSent.data_new = docCptNew.mGetDataDocCptDetail()
            dataToBeSent.data_new.id_doc_cpt_source = Me.docCpt.id_doc_cpt

            if (dataToBeSent.valide_new == "1") {
                var htmlDetail = docCptNew.mGetHmlEtHtmlPiedOriginal("a4", true)
                dataToBeSent.html_new = htmlDetail.body
                dataToBeSent.html_pied_new = htmlDetail.pied
            }

        }

        bddRef.mAjaxCall(dataToBeSent, function (data) {
            if (typeof funcOkAnnule != 'undefined' && funcOkAnnule != null) (new cDocCptDetail(bddRef)).mGetDocCptDetail(bddRef, data.id_doc_cpt_annule, funcOkAnnule);
            if (typeof funcOkNew != 'undefined' && funcOkNew != null) (new cDocCptDetail(bddRef)).mGetDocCptDetail(bddRef, data.id_doc_cpt_new, funcOkNew);
        })

    }

    this.mCloneDocCpt = function (withReglement = false) {
        var docCptDetailDuplik = JSON.parse(JSON.stringify(this.mGetDataDocCptDetail()))
        docCptDetailDuplik.docCpt.dcr = new Date(docCptDetailDuplik.docCpt.dcr)
        if (docCptDetailDuplik.docCpt.date_document != null) docCptDetailDuplik.docCpt.date_document = new Date(docCptDetailDuplik.docCpt.date_document)
        docCptDetailDuplik.docCptLigne.forEach(function (lig) {
            delete lig.div
            lig.dcr = new Date(lig.dcr)
            lig.dmo = new Date(lig.dmo)
        })
        //on avait cela mais je ne comprend pas pourquoi/le flag withReglement était déjà la / je ne sais plus pouquoi on faisait ca
        //a priori pour les impression c bon
        ////on ne clone jamais les réglements
        //docCptDetailDuplik.docCptModeReglement = []
        if (withReglement) {
            docCptDetailDuplik.docCptModeReglement.forEach(function (ligReg) {
                delete ligReg.div
                ligReg.dcr = new Date(ligReg.dcr)
                ligReg.dmo = new Date(ligReg.dmo)
                ligReg.date_reglement = new Date(ligReg.date_reglement)
            })
        } else {
            docCptDetailDuplik.docCptModeReglement = []
        }

        var classDuplik = new cDocCptDetail(bddRef, docCptDetailDuplik)
        //classDuplik.is_externe = this.is_externe
        classDuplik._logoSociete = this._logoSociete
        classDuplik.docCptDuplicata = this.docCptDuplicata
        classDuplik.docCptAvoir = this.docCptAvoir
        return classDuplik
    }

    this.mVerifWithServer = function (funcOk) {
        this.mGetDocCptDetail(bddRef, this.docCpt.id_doc_cpt, function (docCptDetailServeur) {
            var identique = (Me.docCpt.dcr.getTime() == docCptDetailServeur.docCpt.dcr.getTime() &&
                Me.docCpt.dmo.getTime() == docCptDetailServeur.docCpt.dmo.getTime() &&
                Me.docCptClient.dcr.getTime() == docCptDetailServeur.docCptClient.dcr.getTime() &&
                Me.docCptClient.dmo.getTime() == docCptDetailServeur.docCptClient.dmo.getTime() &&
                Me.docCptSociete.dcr.getTime() == docCptDetailServeur.docCptSociete.dcr.getTime() &&
                Me.docCptSociete.dmo.getTime() == docCptDetailServeur.docCptSociete.dmo.getTime() &&
                Me.docCptLigne.length == docCptDetailServeur.docCptLigne.length &&
                Me.docCptModeReglement.length == docCptDetailServeur.docCptModeReglement.length &&
                Me.docCptAvoir.length == docCptDetailServeur.docCptAvoir.length)
            if (identique) {
                Me.docCptLigne.forEach(function (lig, idx) {
                    if (!(lig.dcr.getTime() == docCptDetailServeur.docCptLigne[idx].dcr.getTime() &&
                        lig.dmo.getTime() == docCptDetailServeur.docCptLigne[idx].dmo.getTime())) identique = false
                })
            }
            if (identique) {
                Me.docCptModeReglement.forEach(function (reg, idx) {
                    if (!(reg.dcr.getTime() == docCptDetailServeur.docCptModeReglement[idx].dcr.getTime() &&
                        reg.dmo.getTime() == docCptDetailServeur.docCptModeReglement[idx].dmo.getTime())) identique = false
                })
            }
            if (identique) {
                Me.docCptAvoir.forEach(function (avoir, idx) {
                    if (!(avoir.dcr.getTime() == docCptDetailServeur.docCptAvoir[idx].dcr.getTime() &&
                        avoir.dmo.getTime() == docCptDetailServeur.docCptAvoir[idx].dmo.getTime())) identique = false
                })
            }
            funcOk(identique, docCptDetailServeur)
        })
    }

    this.mGetLstCreationAvoir = function () {
        return this.docCptModeReglement.filter(function (o) { return o.id_mode_reglement == 9 && o.mt < 0 })
    }

    this.mGetLstBonCadeau = function () {
        return this.docCptLigne.filter(function (o) { return o.id_article == 808 })
    }

    //----------------------------
    //#region IMPRESSION

    //on récupère l'urlPdf du document
    this.mGetUrlPdfDocCpt = function (formatPrint, funcOk) {
        mGetUrlPdfImgDocument(formatPrint, funcOk)
    }
    ////on affiche le pdf
    //this.mDisplayPdf = function (formatPrint, funcOk) {
    //    mGetUrlPdfDocument(formatPrint, function (urlPdf) {
    //        $("<div/>").dxCtrlPdfViewer({
    //            urlPdf: urlPdf
    //        })
    //        if (typeof funcOk != 'undefined') funcOk()
    //    })
    //}
    ////genere image ticket et pdf ticket pour impression sur app
    //this.mGenereTicketImageEtPdfAndOpen = function (formatPrint, funcOk) {
    //    var dataImgUrl = mGetImageDocument(formatPrint)
    //    var htmlDetail = mGetHtmlForPdfDocument(formatPrint)
    //    bddRef.mAjaxCall({
    //        command: "generepdfetimageurlprintapp",
    //        dataurl: dataImgUrl,
    //        html: htmlDetail.body,
    //        html_pied: htmlDetail.pied,
    //        type_format: formatPrint,
    //        text_watermark: (Me.docCpt.id_statut_com == "1" ? "BROUILLON" : ""),
    //        top: 200, right: 200, left: 200, bottom: 200,
    //        externe: true,
    //        nom_fichier: Me.mGetNameForPdfFile()
    //    }, function (data) {
    //        forcerFermetureNavigateur = true
    //        window.open(data.urlbase, "_blank")
    //        forcerFermetureNavigateur = false
    //        if (typeof funcOk != 'undefined') funcOk()
    //    }, function () {
    //        jaugeDemarrage.mHide()
    //    }, function () {
    //        mNotify("Impossible d'imprimer le document", "error", 5000)
    //    });
    //}

    ////génère un doc (avec duplicata)
    //function mGenereUrlPdfDocument(printDoc, funcOk) {
    //    if (!Me.isValidated()) {
    //        //le document n'est pas validé, pas besoin de duplicata
    //        mPrintDocument(null, printDoc, funcOk)
    //        //} else if (this.docCpt.nb_impression == 0) {
    //        //    //c'est la première impression, pas besoin de duplicata
    //        //    mPrintDocument(null)
    //    } else {
    //        if (Me.mIsDuplicataActif()) {
    //            if (Me.docCpt.nb_impression == 0) {
    //                //Validé mais sans jamias d'impression, pas de duplicata
    //                mPrintDocument(null, printDoc, funcOk)
    //            } else {
    //                //validé avec déja des impressions, on génère un duplicata avant d'imprimer
    //                Me.mGetDuplicata(null, function (docCptDuplicata) {
    //                    mPrintDocument(docCptDuplicata, printDoc, funcOk)
    //                })
    //            }
    //        } else {
    //            //gestion duplicata désactivé
    //            mPrintDocument(null, printDoc, funcOk)
    //        }
    //    }
    //}
    //function mPrintDocument(docCptDuplicata, printDoc, funcOk) {
    //    if (typeof docCptDuplicata == 'undefined') docCptDuplicata = null
    //    // isFromApp == on est sur une app où on a potentiellement une imprimante
    //    if (Me.isValidated() && docCptDuplicata == null && Me.mIsDuplicataActif()) {
    //        //C'est la première impression
    //        //on rajoute une impression dans la BDD
    //        Me.docCpt.nb_impression = 1
    //        bddRef.getObjet(Me.docCpt).mSaveChamp("nb_impression")
    //    }

    //    if (printDoc) {
    //        //mGenereTicketImageEtPdf(docCptDuplicata, funcOk)
    //        if (isInAppMobile()) {
    //            //on est dans une app
    //            //on a potentiellement une imprimante qui est géré par l'app
    //            //on génére l'image et le pdf et on envoi tout à l'app     
    //            mGenereTicketImageEtPdf(docCptDuplicata, funcOk)
    //        } else {
    //            //on est pas sur une app
    //            //on génère le ticket pdf et on l'affiche
    //            mGetUrlPdfDocument(docCptDuplicata, function (urlPdf) {
    //                $("<div/>").dxCtrlPdfViewer({
    //                    urlPdf: urlPdf
    //                })
    //                if (typeof funcOk != 'undefined') funcOk()
    //            })
    //        }
    //    } else {
    //        mGetUrlPdfDocument(docCptDuplicata, funcOk)
    //    }
    //}

    //return le html du document
    this.mGetHmlEtHtmlPiedOriginal = function (formatPrint, forValidation) {
        return mGetHtmlForPdfDocument(formatPrint, null, forValidation)
    }

    ////return une url du pdf
    //function mGetUrlPdfDocument(formatPrint, funcOk) {
    //    //if (Me.isValidated() && formatPrint == "a4") {
    //    //    //on récupére directement la factureX original
    //    //    var dataToBeSent = {
    //    //        command: "getfacturexoriginal",
    //    //        id_doc_cpt: Me.docCpt.id_doc_cpt,
    //    //        nom_fichier: Me.mGetNameForPdfFile(),
    //    //        externe: "1"
    //    //    }
    //    //    bddRef.mAjaxCall(dataToBeSent, function (data) {
    //    //        funcOk(data.url)
    //    //    }, function () {
    //    //    }, function () {
    //    //        //jaugeDemarrage.mHide()
    //    //        mNotify("Impossible d'imprimer le document", "error", 5000)
    //    //    });
    //    //} else {
    //    var getHtml = mGetHtmlForPdfDocument(formatPrint)
    //    var dataToBeSent = {
    //        command: "generepdffromhtml",
    //        nomFichier: Me.mGetNameForPdfFile(),
    //        html: getHtml.body,
    //        html_pied: getHtml.pied,
    //        externe: "1",
    //        type_format: formatPrint,
    //        text_watermark: (Me.docCpt.id_statut_com == "1" ? "BROUILLON" : ""),
    //        top: 200, right: 200, left: 200, bottom: 200
    //    }
    //    bddRef.mAjaxCall(dataToBeSent, function (data) {
    //        funcOk(data.url)
    //    }, function () {
    //        //jaugeDemarrage.mHide()
    //    }, function () {
    //        mNotify("Impossible d'imprimer le document", "error", 5000)
    //    });
    //    //}
    //}

    this.mPrint = function (formatPrint) {
        var jaugeIsVisibleAvant = jaugeDemarrage.isVisible
        jaugeDemarrage.mShow()
        mGetUrlPdfImgDocument(formatPrint, function (urlPdf) {
            if (formatPrint == "80mm" && isInAppMobile()) {
                //ona sur le serveur urlPdf (et aussi le même fichier image avec .png pour impression thermique)
                forcerFermetureNavigateur = true
                window.open(urlPdf, "_blank")
                forcerFermetureNavigateur = false
                if (!jaugeIsVisibleAvant) jaugeDemarrage.mHide()
            } else {
                $("<div/>").dxCtrlPdfViewer({
                    urlPdf: urlPdf
                })
                if (!jaugeIsVisibleAvant) jaugeDemarrage.mHide()
            }
        })
    }

    //on récupère une urlpdf (mais si sur appmobile, on a aussi une image .png sur le serveur avec le même nom)
    function mGetUrlPdfImgDocument(formatPrint, funcOk) {
        //gestion duplicata
        if (!Me.isValidated()) {
            //le document n'est pas validé, pas besoin de duplicata
            mGetUrlPdf(null)
        } else {
            if (Me.docCpt.id_type_com == "5") { //on est sur un ticket, on gère les duplicatas //if (Me.mIsDuplicataActif()) {
                if (Me.docCpt.nb_impression == 0) {
                    //Validé mais sans jamias d'impression, pas de duplicata
                    mGetUrlPdf(null)
                } else {
                    //validé avec déja des impressions, on génère un duplicata avant d'imprimer
                    Me.mGetDuplicata(null, function (docCptDuplicata) {
                        mGetUrlPdf(docCptDuplicata)
                    })
                }
            } else {
                //gestion duplicata désactivé
                mGetUrlPdf(null)
            }
        }

        async function mGetUrlPdf(docCptDuplicata) {
            var dataImgUrl = null
            if (isInAppMobile() && formatPrint == "80mm") dataImgUrl = await mGetImageDocument(docCptDuplicata)
            var htmlDetail = mGetHtmlForPdfDocument("a4", docCptDuplicata, false)
            bddRef.mAjaxCall({
                command: "generepdfetimageurlprintapp",
                id_doc_cpt: Me.docCpt.id_doc_cpt,
                dataurl: dataImgUrl,
                html: htmlDetail.body,
                html_pied: htmlDetail.pied,
                type_format: formatPrint,
                text_watermark: (Me.docCpt.id_statut_com == "1" ? "BROUILLON" : ""),
                top: 200, right: 200, left: 200, bottom: 200,
                externe: true,
                nom_fichier: Me.mGetNameForPdfFile()
            }, function (data) {
                funcOk(data.urlpdf)
                //forcerFermetureNavigateur = true
                //window.open(data.urlbase, "_blank")
                //forcerFermetureNavigateur = false
                //if (typeof funcOk != 'undefined') funcOk()
            }, function () {
            }, function () {
                mNotify("Impossible d'imprimer le document", "error", 5000)
            });
        }
    }

    //return le html du document
    function mGetHtmlForPdfDocument(formatPrint, docCptDuplicata, forValidation) {
        var width = ((isInAppMobile()) ? "100%" : "350px")
        width = "100%"
        //var $Div = $("<div style='position:absolute;top:0;left:0;max-width:" + width + ";width:" + width + ";' width='" + width + "' border='0' cellspacing='0' cellpadding='0' align='center'/>").appendTo("body")
        var $Div = $("<div style='position:absolute;top:-100000px;left:-100000px;max-width:" + width + ";width:" + width + ";' width='" + width + "' border='0' cellspacing='0' cellpadding='0' align='center'/>").appendTo("body")
        var dxCtrlCaissePapierPdf = null
        var docCptDetailDuplik = Me.mCloneDocCpt(true)
        dxCtrlCaissePapierPdf = $("<div/>").appendTo($Div).dxCtrlDocCptPapier({
            bddCtrl: bddRef,
            docCptDetail: docCptDetailDuplik,
            forPrint: true,
            formatVisu: formatPrint,
            docCptDuplicata: docCptDuplicata,
            forValidation: forValidation
        }).dxCtrlDocCptPapier("instance")
        //if (formatPrint == "a4") {
        //    if (Me.docCpt.id_type_com == "4" || Me.docCpt.id_type_com == "5") {
        //        dxCtrlCaissePapierPdf = $("<div/>").appendTo($Div).dxCtrlDocCpt80cmPapier({
        //            bddCtrl: bddRef,
        //            docCptDetail: docCptDetailDuplik,
        //            forPrint: true,
        //            docCptDuplicata: docCptDuplicata,
        //            formatPrint: formatPrint,
        //            forValidation: forValidation
        //        }).dxCtrlDocCpt80cmPapier("instance")
        //    } else {
        //        dxCtrlCaissePapierPdf = $("<div/>").appendTo($Div).dxCtrlDocCptA4Papier({
        //            bddCtrl: bddRef,
        //            docCptDetail: docCptDetailDuplik,
        //            forPrint: true,
        //            docCptDuplicata: docCptDuplicata,
        //            forValidation: forValidation
        //        }).dxCtrlDocCptA4Papier("instance")
        //    }
        //} else {
        //    dxCtrlCaissePapierPdf = $("<div/>").appendTo($Div).dxCtrlDocCpt80cmPapier({
        //        bddCtrl: bddRef,
        //        docCptDetail: docCptDetailDuplik,
        //        forPrint: true,
        //        docCptDuplicata: docCptDuplicata,
        //        forValidation: forValidation
        //    }).dxCtrlDocCpt80cmPapier("instance")
        //}

        var dataHtml = dxCtrlCaissePapierPdf.mGetHtml(0.7)
        //var $DivHtmlDoc = $(dataHtml.body)
        //$DivHtmlDoc.attr("style", $DivHtmlDoc.attr("style") + ";background-color:transparent;font-weight:400;")

        //var $Result = null
        //$Result = $DivHtmlDoc
        var html = {
            body: dataHtml.body,
            pied: (dataHtml.pied ? dataHtml.pied[0].outerHTML : "")
        }

        //$Result.remove()
        $Div.remove()
        return html
    }

    //génére une image du document
    async function mGetImageDocument(docCptDuplicata) {
        if (isInAppMobile()) {
            var zoom = 4
            var widthBase = "320"
            var widthZoom = widthBase * zoom
            var $DivCaisse = $("<div style='position:absolute;top:-100000px;left:-100000px;max-width:" + widthZoom + "px;min-width:" + widthZoom + "px;width:" + widthZoom + "px;' width='" + widthZoom + "px' border='0' cellspacing='0' cellpadding='0' align='center'/>").appendTo("body")
            var docCptDetailDuplik = Me.mCloneDocCpt(true)
            //dxCtrlCaisseTicketPapier = $("<div style='background-color:white;'/>").appendTo($DivCaisse).dxCtrlDocCpt80cmPapier({
            //    bddCtrl: bddRef,
            //    docCptDetail: docCptDetailDuplik,
            //    docCptDuplicata: docCptDuplicata,
            //    forPrint: true,
            //    formatPrint: "80mm",
            //    zoom: zoom
            //}).dxCtrlDocCpt80cmPapier("instance")
            dxCtrlCaisseTicketPapier = $("<div style='background-color:white;'/>").appendTo($DivCaisse).dxCtrlDocCptPapier({
                bddCtrl: bddRef,
                docCptDetail: docCptDetailDuplik,
                docCptDuplicata: docCptDuplicata,
                forPrint: true,
                formatVisu: "80mm",
                zoom: zoom
            }).dxCtrlDocCptPapier("instance")

            await awaitForRenderComplete($DivCaisse)

            var imag = new cImage(bddRef)
            return imag.mGetImageFromHtmlAsync($DivCaisse)

        } else { return null }
    }

    //#endregion IMPRESSION
    //----------------------------

    //----------------------------

    //#region shared PROPERTY
    this.mGetDocCptDetail = function (bddRef, idDocCpt, funcOk, funcKo) {
        if (typeof nomBase == "undefined") nomBase = bddRef.nom_base
        bddRef.mAjaxCall({ command: "getdoccpt", id_doc_cpt: idDocCpt }, function (data) {
            if (!data.doc_cpt) {
                if (funcKo) funcKo()
            } else {
                var newDataDocCptDetail = {
                    docCpt: data.doc_cpt[0],
                    docCptClient: data.doc_cpt_client[0],
                    docCptSociete: data.doc_cpt_societe[0],
                    docCptLigne: ((typeof data.doc_cpt_ligne == 'undefined') ? [] : data.doc_cpt_ligne),
                    docCptModeReglement: ((typeof data.doc_cpt_mode_reglement == 'undefined') ? [] : data.doc_cpt_mode_reglement),
                    docCptAvoir: ((typeof data.doc_cpt_avoir == 'undefined') ? [] : data.doc_cpt_avoir)
                }
                var clas = new cDocCptDetail(bddRef, newDataDocCptDetail)
                if (clas.docCpt.id_statut_com == 1) clas.mRecalculLigneDetail()
                clas.mGetLogoSociete(function () {
                    funcOk(clas)
                })
            }
        }, null, funcKo)
    }

    this.mCreateNewDocCpt = function (bddRef, option) {
        var lib = ""
        switch (parseInt(option.idTypeCom)) {
            case 1: lib = "un nouveau devis"; break;
            case 2: lib = "une nouvelle commande"; break;
            case 3: lib = "une nouvelle facture"; break;
            case 5: lib = "un nouveau ticket"; break;
        }
        //vérification si on a une société disponible
        if (bddRef.mGetDataSocieteDefaut() == null) {
            //aucune société disponible
            var onClick = null
            if (bddRef.mGetArray("societe").length == 0) {
                //aucune société
                txt = "Vous n'avez pas encore créé votre société pour pouvoir créer <b>" + lib + "</b>. Créez une nouvelle société (dans votre menu utilisateur en haut à droite) pour pouvoir créer <b>" + lib + "</b>.<br/>Cliquer pour créer votre société."
                onClick = function () {
                    var dataSociete = bddRef.getObjet("societe").mGetNewData()
                    bddRef.getObjet(dataSociete).mShowPopup()
                }
            } else {
                //aucune société disponible
                txt = "Toutes vos sociétés sont abandonnées. Aucune société disponible pour la création <b>d'" + lib + "</b>. Réactivez une société ou créez une nouvelle société (dans votre menu utilisateur en haut à droite) pour pouvoir créer <b>" + lib + "</b>."
            }
            mNotify(txt, "error", 12000, onClick)
            //mNotify("Vous devez créer une société pour faire " + lib + ".<br/>Cliquer pour créer votre société.", "warning", 6000, function () {
            //    var dataSociete = bddRef.getObjet("societe").mGetNewData()
            //    bddRef.getObjet(dataSociete).mShowPopup()
            //})
        } else {
            if (typeof option.disableMessageEssai == 'undefined' || !option.disableMessageEssai) {
                bddRef.objCptCli.objetMetier.mShowTooltipVerifEssaiDocCpt(option.target, option.idTypeCom, "Créer " + lib, function () { mNew() })
            } else { mNew() }
            function mNew() {
                var docCptClient = bddRef.getObjet("doc_cpt_client").mGetNewData()
                if (typeof option.idTableClient != 'undefined' && option.idTableClient != null) {
                    var docCptDetail = new cDocCptDetail(bddRef)
                    docCptDetail.msSelectCoordonnesClient(option.idClient, option.idTableClient, docCptClient, function () {
                        mCreate()
                    }, null)
                } else {
                    mCreate()
                }

                function mCreate() {
                    var jaugeDemarrageShowed = false
                    if (!jaugeDemarrage.isVisible) {
                        jaugeDemarrage.mShow()
                        jaugeDemarrageShowed = true
                    }
                    var docCptDetail = {}
                    docCptDetail.docCpt = bddRef.getObjet("doc_cpt").mGetNewData()
                    docCptDetail.docCpt.nom_base = bddRef.nom_base
                    docCptDetail.docCpt.id_type_com = option.idTypeCom
                    docCptDetail.docCpt.nom_ticket = (option.nomTicket ? option.nomTicket : "")
                    docCptDetail.docCpt.id_societe = bddRef.mGetDataSocieteDefaut().id_societe // bddRef.utiCourant.id_societe_defaut
                    if (docCptDetail.docCpt.id_societe == null) docCptDetail.docCpt.id_societe = bddRef.mGetArray("societe")[0].id_societe

                    docCptDetail.docCpt.id_cgv = null
                    var dataCgv = bddRef.getObjet("societe", docCptDetail.docCpt.id_societe).objetMetier.mGetCgvEnCours()
                    if (dataCgv) docCptDetail.docCpt.id_cgv = dataCgv.id_cgv

                    docCptDetail.docCpt.id_utilisateur = bddRef.utiCourant.id_utilisateur
                    docCptDetail.docCpt.percent_arrhes = option.percentArrhes
                    docCptDetail.docCpt.type_operation = ((option.type_operation != 'undefined') ? option.type_operation : "vente")
                    docCptDetail.docCpt.nom_logiciel = parametre.nom
                    docCptDetail.docCpt.version_logiciel = parametre.version.remplacerTout("_", ".")

                    docCptDetail.docCptModeReglement = []
                    //if (typeof option.docCptModeReglement != 'undefined' && option.docCptModeReglement != null) docCptDetail.docCptModeReglement = option.docCptModeReglement

                    docCptDetail.docCptClient = docCptClient
                    //if (typeof option.idTableClient != 'undefined' && option.idTableClient != null) {
                    //    docCptDetail.docCptClient.id_table = option.idTableClient
                    //    docCptDetail.docCptClient.id = option.idClient
                    //}

                    docCptDetail.docCptSociete = bddRef.getObjet("doc_cpt_societe").mGetNewData()
                    docCptDetail.docCptSociete.id_societe = docCptDetail.docCpt.id_societe
                    if (docCptDetail.docCptSociete.id_societe == null) docCptDetail.docCptSociete.id_societe = bddRef.mGetArray("societe")[0].id_societe

                    docCptDetail.docCptLigne = []
                    if (typeof option.docCptLigne != 'undefined' && option.docCptLigne != null) docCptDetail.docCptLigne = option.docCptLigne

                    var classDocCptDetail = new cDocCptDetail(bddRef, docCptDetail)
                    //classDocCptDetail.mUpdateDocCptClient()
                    classDocCptDetail.mUpdateDocCptSociete(null)
                    classDocCptDetail.mRecalculLigneDetail()
                    classDocCptDetail.mSaveNewDocCpt(false, null, option.lst_id_doc_cpt_mode_reglement, option.option_action, function (docCptDetail) {
                        if (option.lst_id_doc_cpt_mode_reglement) {
                            docCptDetail.mRecalculLigneDetail()
                            docCptDetail.mSave(null, function () {
                                if (jaugeDemarrageShowed) jaugeDemarrage.mHide()
                                option.funcOk(docCptDetail)
                            }, function (data) {
                            }, [], [], 1)
                        } else {
                            if (jaugeDemarrageShowed) jaugeDemarrage.mHide()
                            option.funcOk(docCptDetail)
                        }
                    })
                }

            }
        }
    }

    this.msSelectCoordonnesClient = function (id, idTable, dataDocCptClient, funcOk, funcKo) {
        var lstIdTableId = []
        lstIdTableId.push({ id_table: idTable, id: id })
        bddRef.mAjaxCall({
            command: "getdataforinitclientdoccpt",
            data: lstIdTableId,
            id_table: idTable,
            id: id,
            id_doc_cpt_client_exclu: dataDocCptClient.id_doc_cpt_client
        }, function (data) {
            if (typeof data.lstdatatemplate == 'undefined') data.lstdatatemplate = []
            dataTemplate = data.lstdatatemplate[0]
            var cDataSaisieTemplateNew = new cDataSaisie({ bddCtrl: bddRef })
            cDataSaisieTemplateNew.mInitWithDataTemplate(dataTemplate)
            if (bddRef.nom_base.endsWith("_aagest")) {
                //cas facture compte client
                if (data.doc_cpt_client) {
                    console.log("on a une autre def client ");
                    console.log(data.doc_cpt_client)
                }
                cDataSaisieTemplateNew.mSaveInDocCptClient(dataDocCptClient)
                dataDocCptClient.id_table = idTable
                dataDocCptClient.id = id
                dataDocCptClient.has_client = "1"
                funcOk()
            } else {
                if (data.doc_cpt_client) {
                    //on a un doccptclient ancien
                    //on compare au template pour voir si on choisi
                    var cDataSaisieDocCptClientCompare = new cDataSaisie({ bddCtrl: bddRef })
                    cDataSaisieDocCptClientCompare.mInitWithDataDocCptClient(data.doc_cpt_client)
                    if (cDataSaisieTemplateNew.mResumeForDataDocCptClient() == cDataSaisieDocCptClientCompare.mResumeForDataDocCptClient()) {
                        //meme donnée
                        cDataSaisieTemplateNew.mSaveInDocCptClient(dataDocCptClient)
                        dataDocCptClient.id_table = idTable
                        dataDocCptClient.id = id
                        dataDocCptClient.has_client = "1"
                        funcOk()
                    } else {
                        //on propose de choisir
                        var validate = false
                        var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            showMaximize: false,
                            height: "auto",
                            width: 400,
                            title: "Choisissez les coordonnées",
                            contentTemplate: function (contentElement) {
                                var $DivTemplate = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                                    "style='padding:10px;width:100%;height:auto;text-align:left;margin-bottom:30px;line-height:1;display:inline-block;'>" +
                                    "</div>").appendTo(contentElement)
                                $("<div style='opacity:0.5;padding-bottom:10px;'>Information de la fiche</div>").appendTo($DivTemplate)
                                $("<div/>").appendTo($DivTemplate).dxCtrlDataSaisieVisu({
                                    bddCtrl: bddRef,
                                    dataSaisie: cDataSaisieTemplateNew.data
                                })
                                $DivTemplate.on("click", function (e) {
                                    validate = true
                                    cDataSaisieTemplateNew.mSaveInDocCptClient(dataDocCptClient)
                                    dataDocCptClient.id_table = idTable
                                    dataDocCptClient.id = id
                                    dataDocCptClient.has_client = "1"
                                    funcOk()
                                    pop.hide()
                                })
                                var $DivDocCptClient = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                                    "style='padding:10px;width:100%;height:auto;text-align:left;margin-bottom:30px;line-height:1;display:inline-block;'>" +
                                    "</div>").appendTo(contentElement)
                                $("<div style='opacity:0.5;padding-bottom:10px;'>Information du dernier document comptable lié à la fiche</div>").appendTo($DivDocCptClient)
                                $("<div/>").appendTo($DivDocCptClient).dxCtrlDataSaisieVisu({
                                    bddCtrl: bddRef,
                                    dataSaisie: cDataSaisieDocCptClientCompare.data
                                })
                                $DivDocCptClient.on("click", function (e) {
                                    validate = true
                                    cDataSaisieDocCptClientCompare.mSaveInDocCptClient(dataDocCptClient)
                                    dataDocCptClient.id_table = idTable
                                    dataDocCptClient.id = id
                                    dataDocCptClient.has_client = "1"
                                    funcOk()
                                    pop.hide()
                                })
                            },
                            onHiding: function (e) {
                                if (!validate && funcKo) funcKo()
                            }
                        }).dxCtrlPopupBase("instance")
                        pop.show()
                    }
                } else {
                    var cDataSaisieNew = new cDataSaisie({ bddCtrl: bddRef })
                    cDataSaisieNew.mInitWithDataTemplate(dataTemplate)
                    cDataSaisieNew.mSaveInDocCptClient(dataDocCptClient)
                    dataDocCptClient.id_table = idTable
                    dataDocCptClient.id = id
                    dataDocCptClient.has_client = "1"
                    funcOk()
                }
            }
        })
    }

    this.mSaveNewDocCpt = function (valider, iddoccptcmddevis, lst_id_doc_cpt_mode_reglement, optionAction, funcOk, funcKo) {
        var dataToBeSent = {
            command: "createnewdoccpt",
            data: this.mGetDataDocCptDetail(),
            valider: ((valider) ? "1" : "0"),
            iddoccptcmddevis: iddoccptcmddevis,
            lst_id_doc_cpt_mode_reglement: lst_id_doc_cpt_mode_reglement,
            option_action: optionAction
        }
        if (valider) {
            var htmlDetail = this.mGetHmlEtHtmlPiedOriginal("a4", true)
            dataToBeSent.html = htmlDetail.body
            dataToBeSent.html_pied = htmlDetail.pied
        }
        bddRef.mAjaxCall(dataToBeSent, function (data) {
            (new cDocCptDetail(bddRef)).mGetDocCptDetail(bddRef, data.id_doc_cpt, function (newDocCptDetail) {
                if (typeof funcOk != 'undefined' && funcOk != null) funcOk(newDocCptDetail)

                var lstAction = [
                    { nomTableAction: "doc_cpt", action: "new", itemData: newDocCptDetail.docCpt }
                ]
                bddRef.triggerFunctionOnModifiedItemDataWithTempo(lstAction, 200)
            })
        }, null, funcKo)
    }

    this.mDemandeDeleteReglement = function (docCptModeReglement, funcOk) {
        var title = ""
        var txt = ""
        switch (parseInt(docCptModeReglement.id_mode_reglement)) {
            case 1: //cb
                title = "Annulation d'un encaissement CB"
                txt = "Vous allez supprimer un encaissement CB."
                if (docCptModeReglement.key_encaissement_externe != null && docCptModeReglement.key_encaissement_externe.length > 0) {
                    txt += "<br/>Cette CB a été encaissé le <b>" + docCptModeReglement.date_reglement.toDDMMAA() + "."
                }
                txt += "<br/>Veillez à rembourser votre client."
                break;
            case 2: //virement
                title = "Annulation d'un encaissement par virement"
                txt = "Vous allez supprimer un encaissement par virement."
                txt += "<br/>Veillez à rembourser votre client."
                break;
            case 3: //chèque
                title = "Annulation d'un encaissement chèque"
                txt = "Vous allez supprimer un encaissement par chèque."
                txt += "<br/>Veillez à rembourser votre client (ou a rendre le chèque correspondant)."
                break;
            case 4: //espèce
                title = "Annulation d'un encaissement d'espèce"
                txt = "Vous allez supprimer un encaissement espèce."
                if (docCptModeReglement.key_encaissement_externe != null && docCptModeReglement.key_encaissement_externe.length > 0) {
                    txt += "<br/>Ces espèces ont été encaissées le <b>" + docCptModeReglement.date_reglement.toDDMMAA() + " via votre terminal SUMUP."
                }
                txt += "<br/>Veillez à rembourser votre client."
                break;
            case 5: //chque vacances
                title = "Annulation d'un encaissement de chèque vacances"
                txt = "Vous allez supprimer un encaissement par chèques vacances."
                txt += "<br/>Veillez à rembourser votre client (ou a rendre les chèques correspondants)."
                break;
            case 9: //avoir
                if (docCptModeReglement.mt > 0) {
                    //supression utilisation avoir
                    title = "Annulation d'une utilisation d'avoir"
                    txt = "Vous allez supprimer un encaissement via un avoir."
                    txt += "<br/>Celui-ci a déjà été marqué comme utilisé et a été soldé dans votre base de données."
                    txt += "<br/>Veillez à rembourser votre client."
                } else {
                    //suppression création avoir
                    title = "Annulation d'une création d'avoir"
                    txt = "Vous allez supprimer la création d'un avoir."
                    txt += "<br/>Celui-ci a déjà été créé dans votre base de données. Veillez a voir comment gérez sa suppression ou son annulation."
                    txt += "<br/>Veillez à rembourser votre client."
                }
                break;
            case 10: //bon cadeau
                title = "Annulation d'un encaissement de bon cadeau"
                txt = "Vous allez supprimer un encaissement par chèques cadeau."
                txt += "<br/>Le chèque cadeau a déjà été marqué comme utilisé et a été soldé dans votre base de données."
                txt += "<br/>Veillez à rembourser votre client."
                break;
            case 11: //Arrhes
                title = "Annulation d'une utilisation d'arrhes"
                txt = "Vous allez supprimer un réglement via des arrhes."
                txt += "<br/>Ces arrhes seront détachés de votre facture (Vous pourrez les rajouter à nouveau au document via le bouton 'Arrhes' des règlements).<br/>Ces arrhes resteront en déshérance dans votre base de données et il faudra que vous fassiez le nécessaire pour les régulariser."
                txt += "<br/>Veillez à rembourser votre client."
                break;
        }


        var popContentElement = null
        opt = {
            height: "auto",
            width: 600,
            showMaximize: false,
            title: title,
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0")
                popContentElement = contentElement
            },
            onShown: function () {
                $("<div/>").appendTo(popContentElement).html(txt)
                var dxArea = $("<div style='margin:10px 0;' class='dxctrlfocus'/>").appendTo(popContentElement).dxTextArea({
                    labelMode: "floating",
                    label: "Motif de la suppression",
                    maxLength: 2000,
                    value: "",
                    onContentReady: function (e) {
                        if (parametre.isMobile) { e.component.focus() }
                        else {
                            window.setTimeout(function () { e.component.focus() }, 100)
                        }
                    }
                }).dxTextArea("instance")

                mAddButtonOkAnnuler(popContentElement, function () {
                    if (dxArea.option("value") == null || dxArea.option("value").length == 0) {
                        mNotify("Veuillez saisir un motif pour la suppression", "error", 6000)
                        dxArea.focus()
                        return
                    }
                    funcOk(dxArea.option("value"))
                    popup.hide()
                }, function () {
                    popup.hide();
                }, "Annuler", "Confirmer");
            }

        }
        //if (parametre.isMobile) {
        //    opt.position = {
        //        my: "center top",
        //        at: "center top",
        //        of: window,
        //        offset: "0 100" // ou { x: 0, y: 50 }
        //    }
        //    opt.animation = null
        //    opt.deferRendering = false
        //}
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase(opt).dxCtrlPopupBase("instance")
        popup.show()
    }

    this.mGetLasDocCptModeReglementAvoir = function () {
        var lst = []
        this.docCptModeReglement.forEach(function (reg) {
            if (reg.mt < 0 && reg.id_mode_reglement == 9 &&
                reg.annule_destination_id_doc_cpt_mode_reglement == null &&
                reg.annule_origine_id_doc_cpt_mode_reglement == null) lst.push(reg)
        })
        return lst
    }

    this.mGetLstLigneArticleBonCadeau = function () {
        var lst = []
        this.docCptLigne.forEach(function (lig) {
            if (lig.id_article == 808) lst.push(lig)
        })
        return lst
    }

    this.mDelete = function (funcEnd) {
        bddRef.getObjet("doc_cpt", Me.docCpt.id_doc_cpt).mDelData(function () {
            bddRef.mReloadTable(["reservation_hebergement", "reservation_arrhes", "reservation_commande"], function () {
                funcEnd()
            })
        })
    }

    //this.mGetStatutFactureElectroniqueHtmlElement = function () {
    //    var $Div = $("<div style='line-height:1;'/>")

    //    // Code affichage à utiliser pour le lookup dans parametre.lst_statut_affichage.
    //    // Depuis le correctif du 2026-09-07, facturx_id_statut porte directement le bon code
    //    // (cSuperPdpStatusLabels.CodeAffichagePasEnvoyee/.../CodeAffichageDeclareeEreportingSansDocument,
    //    // écrits par cSuperPdpInvoiceSender à chaque étape) -- plus besoin de reconstruire la
    //    // priorité entre états ici.
    //    // Le 2026-09-09 : ajout de CodeAffichageErreurEnRetry (105), séparé de 100, pour que le
    //    // vrai message d'erreur Super PDP s'affiche dès le PREMIER échec plutôt qu'après épuisement
    //    // des tentatives (posé par cSuperPdpInvoiceSender.EnregistrerEchec à chaque échec). 100 ne
    //    // veut donc plus dire QUE "jamais tentée" -- l'ancien repli qui mélangeait les deux sous le
    //    // même texte n'est plus nécessaire ici, écrit directement par le VB.
    //    // Deux cas de repli pour les lignes déjà en base AVANT le correctif du 2026-09-07 (jamais
    //    // réécrites depuis, facturx_id_statut resté NULL) :
    //    // - facturx_envoi_abandonne = 1 -> code d'abandon (102), sinon une vieille facture bloquée
    //    //   s'afficherait à tort comme "à envoyer" au lieu de "action requise".
    //    // - sinon -> code "pas encore envoyée" (100). Pas de repli vers 105 ici : ce code n'a
    //    //   jamais existé avant le 2026-09-09, aucune ligne "legacy" ne peut donc en avoir besoin.
    //    var idStatutAffichage
    //    if (this.docCpt.facturx_id_statut != null) {
    //        idStatutAffichage = this.docCpt.facturx_id_statut
    //    } else if (this.docCpt.facturx_envoi_abandonne == 1) {
    //        idStatutAffichage = 102 // cSuperPdpStatusLabels.CodeAffichageEnvoiAbandonne
    //    } else {
    //        idStatutAffichage = 100 // cSuperPdpStatusLabels.CodeAffichagePasEnvoyee
    //    }

    //    var ligneAffichage = ((typeof parametre !== "undefined" && parametre.lst_statut_envoi_pa) || []).filter(function (s) {
    //        return s.facturx_id_statut === idStatutAffichage
    //    })[0]

    //    var $Statut = $("<div/>")
    //    var titreStatut
    //    if (ligneAffichage) {
    //        $Statut.css("color", ligneAffichage.couleur)
    //        $Statut.text(idStatutAffichage + ":" + ligneAffichage.libelle_court)
    //        // avec_message_erreur : True pour Invalide/Rejetee-api/Refusee/Rejetee-cdar/
    //        // CodeAffichageEnvoiAbandonne/CodeAffichageErreurEnRetry (cf. CreerLigneAffichage côté
    //        // VB) -- reproduit exactement le "docCpt.facturx_dernier_message_erreur || texte par
    //        // défaut" de l'ancien code, pour ces codes-là uniquement. Plus de cas particulier pour
    //        // idStatutAffichage === 100 depuis le 2026-09-09 : ce code ne porte plus jamais de
    //        // message d'erreur (c'est 105 qui en porte un, et il est déjà couvert par
    //        // avec_message_erreur ci-dessus).
    //        titreStatut = (ligneAffichage.avec_message_erreur && this.docCpt.facturx_dernier_message_erreur) ||
    //            ligneAffichage.titre
    //    } else {
    //        // Code reçu/présent mais absent de la table (fr:xxx rare type 214/220, ou nouvelle
    //        // famille pas encore répertoriée côté VB) -- on s'appuie sur le libellé déjà calculé
    //        // côté serveur (facturx_statut) plutôt que sur un texte muet, pour rester honnête sur
    //        // ce qu'on sait.
    //        $Statut.css("color", "grey")
    //        $Statut.text(idStatutAffichage + ":" + this.docCpt.facturx_statut || "Statut inconnu")
    //        titreStatut = "Statut non encore doté d'un affichage dédié (code " + idStatutAffichage + ") : " + (this.docCpt.facturx_statut || "aucun détail disponible") + "."
    //    }
    //    $Div.append($Statut)

    //    // Détail CDAR officiel (cSuperPdpStatusLabels.Detail, exposé côté client via
    //    // parametre.lst_statut_cdar -- cf. cSuperPdpStatusLabels.mGetLstStatutCdar). idStatutAffichage
    //    // n'est jamais null désormais, donc plus besoin de garde explicite contre l'entrée "non
    //    // traitée" (facturx_id_statut: null dans cette légende) : le filter ne peut simplement
    //    // jamais la matcher. Les codes 100-105/-999/-1..-8 ne sont de toute façon jamais dans cette
    //    // liste (limitée à la famille CDAR 200-213), donc rien à exclure de leur côté non plus.
    //    var detailCdar = null
    //    var ligneCdar = ((typeof parametre !== "undefined" && parametre.lst_statut_cdar) || []).filter(function (s) {
    //        return s.facturx_id_statut === idStatutAffichage
    //    })[0]
    //    if (ligneCdar && ligneCdar.facturx_detail) {
    //        detailCdar = ligneCdar.facturx_detail
    //    }

    //    // Indicateur de téléversement, DÉDUIT de idStatutAffichage / facturx_date_envoi plutôt
    //    // que stocké à part (facturx_id_statut reflète le DERNIER événement reçu, donc une fois
    //    // que la facture avance -- validée, envoyée, acceptée, ou un vrai fr:2xx CDAR -- la
    //    // confirmation initiale "le fichier a bien été accepté par Super PDP" disparaîtrait de
    //    // l'écran si on se contentait du badge de statut courant ci-dessus). Affiché dans TOUS
    //    // les cas, sans exception, avec 5 issues possibles :
    //    // - KO (-2, api:invalid) : état définitif, aucun autre événement ne suivra jamais.
    //    // - à vérifier (-999, CodeInconnu) : un événement A été reçu mais on ne sait pas le
    //    //   classer -- surtout ne pas affirmer OK ici, on ne sait justement pas.
    //    // - OK (tout autre code RÉEL connu, api: ou CDAR) : recevoir n'importe quel statut classé
    //    //   prouve, par construction, que le fichier a été accepté au départ. "Réel" est important
    //    //   depuis ce correctif : 100-105 sont des codes SYNTHÉTIQUES (jamais reçus de Super PDP),
    //    //   donc ne prouvent rien sur l'acceptation du fichier -- contrairement à avant, un
    //    //   facturx_id_statut non-null ne suffit plus à conclure "Téléversement OK".
    //    // - erreur en cours de retry (idStatutAffichage = 105, ajouté le 2026-09-09) : rien n'a été
    //    //   accepté, le dernier essai a échoué -- à distinguer explicitement de "en attente" (103)
    //    //   AVANT le test générique sur facturx_date_envoi ci-dessous, sinon une date d'envoi restée
    //    //   d'un tout premier essai réussi ferait croire, à tort, à une confirmation en attente
    //    //   (bug réel constaté doc_cpt 14 le 2026-09-09 : erreur "type_code" affichée comme "en
    //    //   attente de confirmation").
    //    // - déclarée en e-reporting sans document (idStatutAffichage = 104) : idem, à distinguer
    //    //   explicitement AVANT le test générique -- POST /v1.beta/b2bint_invoices est SYNCHRONE
    //    //   (une réponse 2xx EST la confirmation, cf. EnregistrerSuccesSansDocument qui pose 104
    //    //   uniquement sur succès HTTP), donc rien n'est jamais "en attente" ici ; sans cette
    //    //   branche, la date d'envoi posée par ce même code (facturx_date_envoi) faisait retomber
    //    //   ce cas dans le repli générique "en attente de confirmation", qui n'a pas de sens pour
    //    //   un circuit qui ne dépose de toute façon aucun document (bug réel constaté le
    //    //   2026-09-09, remonté après correction du pivot B2BInt).
    //    // - en attente (idStatutAffichage = 100, aucun événement reçu) : ni OK ni KO confirmé.
    //    // - pas envoyée (aucune tentative d'envoi) : le téléversement n'a pas encore eu lieu.
    //    var estCodeReel = idStatutAffichage < 100 || idStatutAffichage > 105
    //    var $Televersement = $("<div/>")
    //    var titreTeleversement = ""
    //    $Televersement.css("font-size", "0.85em")
    //    if (idStatutAffichage == -2) {
    //        $Televersement.css("color", "red")
    //        $Televersement.text("Téléversement KO" + (this.docCpt.facturx_dernier_message_erreur ? " — " + this.docCpt.facturx_dernier_message_erreur : ""))
    //        titreTeleversement = this.docCpt.facturx_dernier_message_erreur || "Le fichier envoyé à notre prestataire n'a pas pu être accepté (erreur de format)."
    //    } else if (idStatutAffichage == -999) {
    //        $Televersement.css("color", "grey")
    //        $Televersement.text("Téléversement : à vérifier")
    //        titreTeleversement = "Un statut technique non reconnu a été reçu pour cette facture : impossible de confirmer si le téléversement a réussi. Notre équipe technique a été alertée."
    //    } else if (estCodeReel) {
    //        $Televersement.css("color", "green")
    //        $Televersement.text("Téléversement OK")
    //        titreTeleversement = "Le fichier envoyé à notre prestataire a bien été reçu et validé par le PA de votre client (format correct)."
    //    } else if (idStatutAffichage == 105) {
    //        $Televersement.css("color", "red")
    //        $Televersement.text("Téléversement : échec, nouvel essai automatique")
    //        titreTeleversement = this.docCpt.facturx_dernier_message_erreur || "L'envoi à notre prestataire a échoué. Un nouvel essai automatique est programmé."
    //    } else if (idStatutAffichage == 104) {
    //        $Televersement.css("color", "green")
    //        $Televersement.text("Téléversement OK")
    //        titreTeleversement = "Cette facture a été transmise et acceptée par notre prestataire dès la déclaration -- ce circuit (e-reporting biens+services) ne dépose aucun document chez votre client, il n'y a pas d'étape de confirmation supplémentaire à attendre."
    //    } else if (this.docCpt.facturx_date_envoi != null) {
    //        $Televersement.css("color", "orange")
    //        $Televersement.text("Téléversement : en attente de confirmation")
    //        titreTeleversement = "Votre facture a été envoyée à notre prestataire, en attente de confirmation de réception."
    //    } else {
    //        $Televersement.css("color", "grey")
    //        $Televersement.text("Téléversement : pas encore envoyée")
    //        titreTeleversement = "Cette facture n'a pas encore été transférée à notre prestataire."
    //    }
    //    $Div.append($Televersement)

    //    // Tous les titres (tooltips) sont regroupés sur $Div plutôt que sur chaque sous-élément :
    //    // un seul survol de tout le bloc suffit à voir l'explication du statut ET celle du
    //    // téléversement, pas besoin de viser précisément la bonne ligne. HTML supporté par le
    //    // composant de tooltip utilisé ici -- on peut donc mettre en forme (gras + saut de ligne)
    //    // plutôt qu'un texte brut concaténé.
    //    $Div.attr("title",
    //        "<strong>Statut :</strong> " + titreStatut +
    //        (detailCdar ? "<br/><br/><strong>Détail CDAR :</strong> " + detailCdar : "") +
    //        (titreTeleversement ? "<br/><strong>Téléversement :</strong> " + titreTeleversement : "")
    //    )

    //    return $Div
    //}

    this.mAfficheReglement = function (onErrorSaveDocCpt, lstDataModeReglement, allowSaisieReglement, hideDateReglement, onAddReglement, onChangeClient, onPasseFacture, onDemandeScinder, onValideTicket) {

        if (Me.docCpt.reste_a_payer <= 0 && Me.docCpt.id_type_com == "5" && Me.docCpt.id_statut_com == 1) {
            mAfficheFinaliseTicket()
        } else {
            var dataMobile = null
            dataMobile = {
                tel_code_pays: this.docCptClient.mob_code_pays,
                tel_number: this.docCptClient.mob_number,
                tel_complet: this.docCptClient.mob_complet,
                tel_sms: this.docCptClient.mob_sms,
                tel_error: this.docCptClient.mob_error,
                tel_num_type: this.docCptClient.mob_num_type
            }
            if (lstDataModeReglement) lstDataModeReglement = bddRef.getObjet("mode_reglement").objetMetier.mGetLstDataModeReglementDispo()
            var dxRegSaisie = $("<div/>").appendTo("body").dxCtrlPopupUiSaisieReglementDocCpt({
                bddCtrl: bddRef,
                idTable: bddRef.getObjet(this.docCpt).mGetTable().id_table,
                id: this.docCpt.id_doc_cpt,
                dataSociete: bddRef.getObjet("societe", this.docCpt.id_societe).data,
                nomBase: this.docCpt.nom_base,
                lstDataModeReglement: lstDataModeReglement,
                allowSaisieReglement: allowSaisieReglement,
                hideDateReglement: hideDateReglement,
                mtMax: this.docCpt.reste_a_payer,
                adresseEmail: this.docCptClient.adresse_email,
                docCptDetail: this,
                dataMobile: dataMobile,
                onAddReglement: function (dxPopupRight, e) {
                    (new cDocCptDetail(bddRef)).mGetDocCptDetail(bddRef, Me.docCpt.id_doc_cpt, function (updateDocCptDetail) {
                        onAddReglement(dxPopupRight, updateDocCptDetail)
                        if (updateDocCptDetail.docCpt.reste_a_payer <= 0 && Me.docCpt.id_statut_com == 1) {
                            dxPopupRight.mClose()
                            if (updateDocCptDetail.docCpt.id_type_com == "5") {
                                //ticket/affiche finalise
                                updateDocCptDetail.mAfficheReglement(onErrorSaveDocCpt, lstDataModeReglement, allowSaisieReglement, hideDateReglement, onAddReglement, onChangeClient, onPasseFacture, onDemandeScinder, onValideTicket)
                            }
                        }
                    }, function () { })
                },
                onPasseFacture: onPasseFacture,
                onDemandeScinder: onDemandeScinder,
            })
        }


        function mAfficheFinaliseTicket() {
            $("<div/>").appendTo("body").dxCtrlPopupValideDocCptTicket({
                bddCtrl: bddRef,
                idTable: bddRef.getObjet(Me.docCpt).mGetTable().id_table,
                id: Me.docCpt.id_doc_cpt,
                dataSociete: bddRef.getObjet("societe", Me.docCpt.id_societe).data,
                adresseEmail: Me.docCptClient.adresse_email,
                docCptDetail: Me,
                dataMobile: dataMobile,
                onChangeClient: onChangeClient,
                onErrorSaveDocCpt: onErrorSaveDocCpt,
                onValide: function (dxPopupRight) {
                    if (Me.docCpt.id_statut_com == "1") {
                        Me.mValideDocument(Me.docCpt.id_type_com, function () {
                            //imprimer
                            //envoi par mail
                            onValideTicket(Me)
                            dxPopupRight.mClose()
                        }, onErrorSaveDocCpt)
                    } else {

                    }
                },
                onAddReglement: function (dxPopupRight, e) {
                    //on a créer le rendu monnaie
                    //on valide le ticket
                    (new cDocCptDetail(bddRef)).mGetDocCptDetail(bddRef, Me.docCpt.id_doc_cpt, function (updateDocCptDetail) {
                        Me.mValideDocument(updateDocCptDetail.docCpt.id_type_com, function () {
                            //imprimer
                            //envoi par mail
                            onValideTicket(updateDocCptDetail)
                            dxPopupRight.mClose()
                        }, onErrorSaveDocCpt)
                    }, onErrorSaveDocCpt)
                }
            })
        }
    }


}